<template>
  <div class="container-mapas">
    <div class="left-box">
      <div class="title-section">
        <h2>Nordeste Setentrional</h2>
      </div>
      <div>
          <!-- <p class="texto-apoio">A região chamada Nordeste Setentrional agrupa Ceará, Rio Grande do Norte, Paraíba e Pernambuco, que são os estados beneficiados pelo Projeto de Integração do Rio São Francisco (PISF).</p> -->
          <div class="downloand">
              <ul>
								<li>
                      <p>Fichas da Região</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Nordeste Setentrional.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Ceará - CE</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Ceara.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Paraíba - PB</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Paraiba.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Pernambuco - PE</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Pernambuco.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Rio Grande do Norte - RN</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Rio Grande do Norte.zip" target="_blank">Download</a>
                  </li>
              </ul>
          </div>
          <div class="interacao-intervencao">
			<svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22">
    			<path fill="#7E7E7E" fill-rule="evenodd" d="M13.278 12.965l-5.436-.492-.008-6.237C7.834 5.8 7.464 5 6.57 5c-.695 0-1.264.554-1.264 1.236V16.74l-1.049-1.473a1.255 1.255 0 0 0-1.894-.162 1.206 1.206 0 0 0-.141 1.559L4.94 21.62c.235.335.623.38 1.037.38h6.086c1.201 0 2.234-.678 2.47-1.832l.418-4.45c.249-1.223-.469-2.359-1.673-2.753M1.3 9C.582 9 0 8.464 0 7.8V6.3c0-8.4 13-8.4 13 0v1.5c0 .664-.582 1.2-1.3 1.2-.718 0-1.3-.536-1.3-1.2V6.3c0-4.8-7.8-4.8-7.8 0v1.5c0 .664-.582 1.2-1.3 1.2"/>
			</svg>
			<p>Explore o mapa e tenha acesso aos detalhes e à ficha-modelo de cada intervenção.</p>
		  </div>
      </div>
    </div>
    <div class="right-box">
      <div class="mapa">
				 <modal />
         <SvgPanZoom :dblClickZoomEnabled="false" :zoomEnabled="true" :controlIconsEnabled="true" :fit="false"  :center="true" :contain="true">
					 	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1076 1068" style="enable-background:new 0 0 1076 1068;" xml:space="preserve">
<path class="st0" d="M856.3,530l26.2,140.2l-1.7,2.4c-0.3,0.5-23.5,33-54.5,76.2l-0.7-0.5l0.4-14.1l-6.4-0.2
	c17-23.7,33.3-46.5,48-67.1l-8.6-46.3l4.6-1.8l-5.1-13.1l-2.1,0.8l-11.8-63.3l8.6,1l1.6-14L856.3,530z"/>
<path class="st1" d="M858.9,620.7l8.6,46.3c-14.6,20.6-31,43.5-48,67.1L493.3,725l-20-25.8l-124.1,75.9l-21-72.4l-34.8,19.9
	L348.8,618c58.7,12.1,143.3,29.8,148.8,31.5c3,1,6.3,2.1,87.4-17.7c28.5-7,56.9-14.2,70.3-17.6l7.1,83.2L858.9,620.7z"/>
<polygon class="st0" points="858.3,605.8 863.5,618.9 858.9,620.7 856.3,606.6 "/>
<path class="st0" d="M856.3,606.6l2.6,14.1l-196.5,76.7l-7.1-83.2c-13.4,3.4-41.8,10.6-70.3,17.6c-81.1,19.8-84.5,18.7-87.4,17.7
	c-5.5-1.7-90.1-19.4-148.8-31.5l-55.4,104.5l-12.1,6.9l-5.9-3.1l65.8-124.2l4.9,1l3.9,0.7l9.6,2.3h1.2
	c37.3,7.7,128.6,26.7,140.2,29.8c2.6-0.1,9.8-1.4,19.9-3.6c32.6-7,96.2-22.8,138.8-33.8l8.1-2.1l6.9,81L856.3,606.6z"/>
<polygon class="st0" points="829.4,385.8 856.3,530 854.7,530.3 841.7,528.8 817.4,398.1 626.1,369 610.9,366.7 618.1,355.4
	618.4,353.6 "/>
<path class="st1" d="M844.5,543.3l11.8,63.3l-181.4,70.8l-6.9-81l-8.1,2.1c-42.7,11-106.2,26.8-138.8,33.8l-0.1-0.6l8.9-107.2
	l102.5-20.1L617.5,549l81,25.1l19.2-45.6L844.5,543.3z"/>
<polygon class="st0" points="854.7,530.3 853,544.3 844.5,543.3 841.7,528.8 "/>
<polygon class="st0" points="841.7,528.8 844.5,543.3 717.6,528.5 698.4,574.1 617.5,549 632.3,504.4 529.8,524.5 529.2,522.3
	537.9,508.5 653.3,485.9 635.4,539.8 690.4,556.9 708.8,513.3 "/>
<polygon class="st1" points="817.4,398.1 841.7,528.8 708.8,513.3 690.4,556.9 635.4,539.8 653.3,485.9 537.9,508.5 626.1,369 "/>
<path class="st0" d="M825.9,734.3l-0.4,14.1l-15.9-0.5c3.3-4.6,6.6-9.2,9.9-13.8L825.9,734.3z"/>
<path class="st0" d="M488.3,725.1l331.3,9.1c-3.3,4.6-6.6,9.2-9.9,13.8l-321.8-8.5L488.3,725.1z"/>
<polygon class="st0" points="626.1,369 528.2,523.8 516.7,512.7 610.9,366.7 "/>
<polygon class="st0" points="618.4,353.6 618.1,355.4 610.9,366.7 604.9,365.8 603.5,364.8 407.6,220.2 295.6,192 293.4,177.5
	293.5,176.9 413.8,207.3 610.4,352.4 "/>
<path class="st1" d="M604.9,365.8l6,0.9L517,512l-0.3,0.7l-9.8,117.8l14,1.2l0.1,0.6c-10.1,2.2-17.3,3.5-19.9,3.6
	c-11.6-3.1-102.9-22.1-140.2-29.8L295.6,192l112,28.2l195.8,144.5L604.9,365.8z"/>
<polygon class="st0" points="531.3,505.6 529.8,524.5 521,632.3 506.5,635.2 516.7,512.7 518.9,512.2 520.9,511.9 "/>
<path class="st0" d="M296.2,192l65.3,414.1l-14.5-3l-0.2-0.1l-65.4-414.8L296.2,192z"/>
<polygon class="st0" points="293.5,176.9 296.2,192 281.4,188.2 280,179.7 "/>
<polyline class="st0" points="289.7,734.6 281.4,729.4 286.7,726.4 293.4,722.5 328.2,702.7 349.2,775.1 473.4,699.2 493.4,725.1
	488.3,724.9 487.9,739 486.9,739.7 469.9,717.8 340.9,796.7 320.2,719.4 "/>
<g @click="mostarIntervencao(27)">
	<circle class="st2" cx="820.4" cy="530.3" r="14.5"/>
	<circle class="st3" cx="820.4" cy="530.3" r="13"/>
	<circle class="st4" cx="820.4" cy="530.3" r="11.7"/>
	<path class="st5" d="M820.4,542.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C832.8,537.1,827.2,542.7,820.4,542.7z M820.4,519.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C831.4,524.1,826.5,519.2,820.4,519.2L820.4,519.2z"/>
	<g>
		<path class="st6" d="M819.7,526.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C819.9,526.2,819.8,526.2,819.7,526.2z"/>
		<path class="st6" d="M819.7,525.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C819.9,525.2,819.8,525.2,819.7,525.2z"/>
		<path class="st6" d="M812.7,536.2c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C812.9,536.2,812.8,536.2,812.7,536.2z"/>
		<path class="st6" d="M812.6,527.1c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0h-0.2l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C812.4,526.9,812.5,527,812.6,527.1z"/>
		<path class="st6" d="M812.7,527.2C812.7,527.2,812.6,527.1,812.7,527.2C812.6,527.1,812.6,527.1,812.7,527.2L812.7,527.2z"/>
		<path class="st6" d="M812.8,529.2C812.7,529.2,812.7,529.2,812.8,529.2C812.7,529.2,812.7,529.2,812.8,529.2L812.8,529.2z"/>
		<path class="st6" d="M817.5,527.9c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C817.7,528.2,817.6,528,817.5,527.9L817.5,527.9z"/>
		<path class="st6" d="M817.5,529.9c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1h-0.3h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C817.8,530.3,817.7,530.1,817.5,529.9L817.5,529.9z"
			/>
		<path class="st6" d="M817.5,532c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5V532h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C817.6,532,817.5,532,817.5,532z"/>
		<path class="st6" d="M817,534L817,534c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C817.3,533.8,817.1,533.9,817,534z"/>
		<path class="st6" d="M824.5,534.8c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0h-0.3h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C824.1,535.1,824.4,535,824.5,534.8z
			 M819.4,536.2h-0.7v-1h0.7V536.2z M820,536.2v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4
			s-0.4,0.1-0.4,0.3v0.1v7h-0.6v-10.4h2.4l2.2,12L820,536.2L820,536.2z"/>
	</g>
</g>
<g @click="mostarIntervencao(18)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(18)">
	<circle class="st2" cx="644.4" cy="540.7" r="14.5"/>
	<circle class="st3" cx="644.4" cy="540.7" r="13"/>
	<circle class="st4" cx="644.4" cy="540.7" r="11.7"/>
	<path class="st5" d="M644.4,553.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C656.8,547.5,651.2,553.1,644.4,553.1z M644.4,529.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C655.4,534.5,650.5,529.6,644.4,529.6L644.4,529.6z"/>
	<g>
		<path class="st6" d="M643.7,536.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C643.9,536.6,643.8,536.6,643.7,536.6z"/>
		<path class="st6" d="M643.7,535.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C643.9,535.6,643.8,535.6,643.7,535.6z"/>
		<path class="st6" d="M636.7,546.6c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C636.9,546.6,636.8,546.6,636.7,546.6z"/>
		<path class="st6" d="M636.6,537.5c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0h-0.2l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C636.4,537.3,636.5,537.4,636.6,537.5z"/>
		<path class="st6" d="M636.7,537.6C636.7,537.6,636.6,537.5,636.7,537.6C636.6,537.5,636.6,537.5,636.7,537.6L636.7,537.6z"/>
		<path class="st6" d="M636.8,539.6C636.7,539.6,636.7,539.6,636.8,539.6C636.7,539.6,636.7,539.6,636.8,539.6L636.8,539.6z"/>
		<path class="st6" d="M641.5,538.3c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C641.7,538.6,641.6,538.4,641.5,538.3L641.5,538.3z"/>
		<path class="st6" d="M641.5,540.3c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1h-0.3h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C641.8,540.7,641.7,540.5,641.5,540.3L641.5,540.3z"
			/>
		<path class="st6" d="M641.5,542.4c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C641.6,542.4,641.5,542.4,641.5,542.4z"/>
		<path class="st6" d="M641,544.4L641,544.4c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C641.3,544.2,641.1,544.3,641,544.4z"/>
		<path class="st6" d="M648.5,545.2c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0h-0.3h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C648.1,545.5,648.4,545.4,648.5,545.2z
			 M643.4,546.6h-0.7v-1h0.7V546.6z M644,546.6v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4
			s-0.4,0.1-0.4,0.3v0.1v7h-0.6v-10.4h2.4l2.2,12L644,546.6L644,546.6z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(22)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(22)">
	<circle class="st2" cx="661.2" cy="483.1" r="14.5"/>
	<circle class="st3" cx="661.2" cy="483.1" r="13"/>
	<circle class="st4" cx="661.2" cy="483.1" r="11.7"/>
	<path class="st5" d="M661.2,495.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C673.6,489.9,668,495.5,661.2,495.5z M661.2,472c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C672.2,476.9,667.3,472,661.2,472L661.2,472z"/>
	<g>
		<path class="st6" d="M660.5,479c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2s0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C660.7,479,660.6,479,660.5,479z"/>
		<path class="st6" d="M660.5,478c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C660.7,478,660.6,478,660.5,478z"/>
		<path class="st6" d="M653.5,489c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C653.7,489,653.6,489,653.5,489z"/>
		<path class="st6" d="M653.4,479.9c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0h-0.2l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C653.2,479.7,653.3,479.8,653.4,479.9z"/>
		<path class="st6" d="M653.5,480C653.5,480,653.4,479.9,653.5,480C653.4,479.9,653.4,479.9,653.5,480L653.5,480z"/>
		<path class="st6" d="M653.6,482C653.5,482,653.5,482,653.6,482C653.5,482,653.5,482,653.6,482L653.6,482z"/>
		<path class="st6" d="M658.3,480.7c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C658.5,481,658.4,480.8,658.3,480.7L658.3,480.7z"/>
		<path class="st6" d="M658.3,482.7c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1h-0.3h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C658.6,483.1,658.5,482.9,658.3,482.7L658.3,482.7z"
			/>
		<path class="st6" d="M658.3,484.8c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C658.4,484.8,658.3,484.8,658.3,484.8z"/>
		<path class="st6" d="M657.8,486.8L657.8,486.8c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C658.1,486.6,657.9,486.7,657.8,486.8z"/>
		<path class="st6" d="M665.3,487.6c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0h-0.3H667l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3H665l-0.2-1C664.9,487.9,665.2,487.8,665.3,487.6z
			 M660.2,489h-0.7v-1h0.7V489z M660.8,489v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4
			s-0.4,0.1-0.4,0.3v0.1v7h-0.6V477h2.4l2.2,12H660.8z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(53)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(53)">
	<circle class="st2" cx="850.5" cy="620.7" r="14.5"/>
	<circle class="st3" cx="850.5" cy="620.7" r="13"/>
	<circle class="st4" cx="850.5" cy="620.7" r="11.7"/>
	<path class="st5" d="M850.5,633.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C862.9,627.5,857.3,633.1,850.5,633.1z M850.5,609.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C861.5,614.5,856.6,609.6,850.5,609.6L850.5,609.6z"/>
	<g>
		<path class="st6" d="M849.8,616.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C850,616.6,849.9,616.6,849.8,616.6z"/>
		<path class="st6" d="M849.8,615.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C850,615.6,849.9,615.6,849.8,615.6z"/>
		<path class="st6" d="M842.8,626.6c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C843,626.6,842.9,626.6,842.8,626.6z"/>
		<path class="st6" d="M842.7,617.5c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0h-0.2l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C842.5,617.3,842.6,617.4,842.7,617.5z"/>
		<path class="st6" d="M842.8,617.6C842.8,617.6,842.7,617.5,842.8,617.6C842.7,617.5,842.7,617.5,842.8,617.6L842.8,617.6z"/>
		<path class="st6" d="M842.9,619.6C842.8,619.6,842.8,619.6,842.9,619.6C842.8,619.6,842.8,619.6,842.9,619.6L842.9,619.6z"/>
		<path class="st6" d="M847.6,618.3c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C847.8,618.6,847.7,618.4,847.6,618.3L847.6,618.3z"/>
		<path class="st6" d="M847.6,620.3c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1h-0.3h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C847.9,620.7,847.8,620.5,847.6,620.3L847.6,620.3z"
			/>
		<path class="st6" d="M847.6,622.4c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C847.7,622.4,847.6,622.4,847.6,622.4z"/>
		<path class="st6" d="M847.1,624.4L847.1,624.4c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C847.4,624.2,847.2,624.3,847.1,624.4z"/>
		<path class="st6" d="M854.6,625.2c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0h-0.3h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3H844c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C854.2,625.5,854.5,625.4,854.6,625.2z
			 M849.5,626.6h-0.7v-1h0.7V626.6z M850.1,626.6v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7
			c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3v0.1v7h-0.6v-10.4h2.4l2.2,12L850.1,626.6L850.1,626.6z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(56)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(56)">
	<circle class="st2" cx="849.5" cy="671.9" r="14.5"/>
	<circle class="st3" cx="849.5" cy="671.9" r="13"/>
	<circle class="st4" cx="849.5" cy="671.9" r="11.7"/>
	<path class="st5" d="M849.5,684.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C861.9,678.7,856.3,684.3,849.5,684.3z M849.5,660.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C860.5,665.7,855.6,660.8,849.5,660.8L849.5,660.8z"/>
	<g>
		<path class="st6" d="M848.8,667.8c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C849,667.8,848.9,667.8,848.8,667.8z"/>
		<path class="st6" d="M848.8,666.8c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C849,666.8,848.9,666.8,848.8,666.8z"/>
		<path class="st6" d="M841.8,677.8c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C842,677.8,841.9,677.8,841.8,677.8z"/>
		<path class="st6" d="M841.7,668.7c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0h-0.2l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C841.5,668.5,841.6,668.6,841.7,668.7z"/>
		<path class="st6" d="M841.8,668.8C841.8,668.8,841.7,668.7,841.8,668.8C841.7,668.7,841.7,668.7,841.8,668.8L841.8,668.8z"/>
		<path class="st6" d="M841.9,670.8C841.8,670.8,841.8,670.8,841.9,670.8C841.8,670.8,841.8,670.8,841.9,670.8L841.9,670.8z"/>
		<path class="st6" d="M846.6,669.5c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C846.8,669.8,846.7,669.6,846.6,669.5L846.6,669.5z"/>
		<path class="st6" d="M846.6,671.5c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1h-0.3h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C846.9,671.9,846.8,671.7,846.6,671.5L846.6,671.5z"
			/>
		<path class="st6" d="M846.6,673.6c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C846.7,673.6,846.6,673.6,846.6,673.6z"/>
		<path class="st6" d="M846.1,675.6L846.1,675.6c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C846.4,675.4,846.2,675.5,846.1,675.6z"/>
		<path class="st6" d="M853.6,676.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0h-0.3h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3H843c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C853.2,676.7,853.5,676.6,853.6,676.4z
			 M848.5,677.8h-0.7v-1h0.7V677.8z M849.1,677.8v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7
			c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3v0.1v7h-0.6v-10.4h2.4l2.2,12L849.1,677.8L849.1,677.8z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(57)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(57)">
	<circle class="st2" cx="838.8" cy="697.1" r="14.5"/>
	<circle class="st3" cx="838.8" cy="697.1" r="13"/>
	<circle class="st4" cx="838.8" cy="697.1" r="11.7"/>
	<path class="st5" d="M838.8,709.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C851.2,703.9,845.6,709.5,838.8,709.5z M838.8,686c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C849.8,690.9,844.9,686,838.8,686L838.8,686z"/>
	<g>
		<path class="st6" d="M838.1,693c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C838.3,693,838.2,693,838.1,693z"/>
		<path class="st6" d="M838.1,692c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C838.3,692,838.2,692,838.1,692z"/>
		<path class="st6" d="M831.1,703c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C831.3,703,831.2,703,831.1,703z"/>
		<path class="st6" d="M831,693.9c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0H834l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C830.8,693.7,830.9,693.8,831,693.9z"/>
		<path class="st6" d="M831.1,694C831.1,694,831,693.9,831.1,694C831,693.9,831,693.9,831.1,694L831.1,694z"/>
		<path class="st6" d="M831.2,696C831.1,696,831.1,696,831.2,696C831.1,696,831.1,696,831.2,696L831.2,696z"/>
		<path class="st6" d="M835.9,694.7c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C836.1,695,836,694.8,835.9,694.7L835.9,694.7z"/>
		<path class="st6" d="M835.9,696.7c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1h-0.3h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C836.2,697.1,836.1,696.9,835.9,696.7L835.9,696.7z"
			/>
		<path class="st6" d="M835.9,698.8c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1H834l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C836,698.8,835.9,698.8,835.9,698.8z"/>
		<path class="st6" d="M835.4,700.8L835.4,700.8c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C835.7,700.6,835.5,700.7,835.4,700.8z"/>
		<path class="st6" d="M842.9,701.6c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0h-0.3h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C842.5,701.9,842.8,701.8,842.9,701.6z
			 M837.8,703h-0.7v-1h0.7V703z M838.4,703v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4
			s-0.4,0.1-0.4,0.3v0.1v7h-0.6V691h2.4l2.2,12H838.4z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(50)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(50)">
	<circle class="st2" cx="831.4" cy="724.1" r="14.5"/>
	<circle class="st3" cx="831.4" cy="724.1" r="13"/>
	<circle class="st4" cx="831.4" cy="724.1" r="11.7"/>
	<path class="st5" d="M831.4,736.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C843.8,730.9,838.2,736.5,831.4,736.5z M831.4,713c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C842.4,717.9,837.5,713,831.4,713L831.4,713z"/>
	<g>
		<path class="st6" d="M830.7,720c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C830.9,720,830.8,720,830.7,720z"/>
		<path class="st6" d="M830.7,719c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C830.9,719,830.8,719,830.7,719z"/>
		<path class="st6" d="M823.7,730c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C823.9,730,823.8,730,823.7,730z"/>
		<path class="st6" d="M823.6,720.9c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0h-0.2l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C823.4,720.7,823.5,720.8,823.6,720.9z"/>
		<path class="st6" d="M823.7,721C823.7,721,823.6,720.9,823.7,721C823.6,720.9,823.6,720.9,823.7,721L823.7,721z"/>
		<path class="st6" d="M823.8,723C823.7,723,823.7,723,823.8,723C823.7,723,823.7,723,823.8,723L823.8,723z"/>
		<path class="st6" d="M828.5,721.7c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C828.7,722,828.6,721.8,828.5,721.7L828.5,721.7z"/>
		<path class="st6" d="M828.5,723.7c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1h-0.3h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C828.8,724.1,828.7,723.9,828.5,723.7L828.5,723.7z"
			/>
		<path class="st6" d="M828.5,725.8c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C828.6,725.8,828.5,725.8,828.5,725.8z"/>
		<path class="st6" d="M828,727.8L828,727.8c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C828.3,727.6,828.1,727.7,828,727.8z"/>
		<path class="st6" d="M835.5,728.6c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0h-0.3h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C835.1,728.9,835.4,728.8,835.5,728.6z
			 M830.4,730h-0.7v-1h0.7V730z M831,730v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4
			s-0.4,0.1-0.4,0.3v0.1v7h-0.6V718h2.4l2.2,12H831z"/>
	</g>
	</v-touch>
</g>
<!-- <g>
	<circle class="st2" cx="812.7" cy="742.3" r="14.5"/>
	<circle class="st3" cx="812.7" cy="742.3" r="13"/>
	<circle class="st4" cx="812.7" cy="742.3" r="11.7"/>
	<path class="st5" d="M812.6,754.7c-6.9-0.1-12.4-5.7-12.3-12.5c0.1-6.9,5.7-12.4,12.5-12.3c6.9,0.1,12.4,5.7,12.3,12.5l0,0
		C825,749.2,819.4,754.7,812.6,754.7z M812.8,731.2c-6.1,0-11.1,4.9-11.2,11s4.9,11.1,11,11.2s11.1-4.9,11.2-11l0,0
		C823.7,736.2,818.9,731.2,812.8,731.2L812.8,731.2z"/>
	<g>
		<path class="st6" d="M812,738.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C812.2,738.2,812.1,738.2,812,738.2z"/>
		<path class="st6" d="M812,737.2c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C812.2,737.2,812.1,737.2,812,737.2z"/>
		<path class="st6" d="M805,748.1c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C805.2,748.1,805.1,748.1,805,748.1z"/>
		<path class="st6" d="M804.9,739c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5s-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.5l0-0.1l0,0l0,0l0,0l-0.2,0l0,0c0,0,0,0-0.1,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4
			c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C804.7,738.8,804.8,738.9,804.9,739z"/>
		<path class="st6" d="M805,739.1C805,739.1,804.9,739,805,739.1C804.9,739,804.9,739,805,739.1L805,739.1z"/>
		<path class="st6" d="M805.1,741.1C805,741.1,805,741.1,805.1,741.1C805,741.1,805,741.1,805.1,741.1L805.1,741.1z"/>
		<path class="st6" d="M809.8,739.9c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l0,0l-0.3,0
			l-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.5-0.1,0.9-0.3,1.2-0.8
			C810,740.2,809.9,740,809.8,739.9L809.8,739.9z"/>
		<path class="st6" d="M809.8,741.9c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l-0.1,0l-0.3,0
			l-0.1,0l0,0.1c-0.3,0.3-0.5,0.6-0.7,0.5c-0.2-0.1-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.5-0.1,0.9-0.3,1.2-0.8
			C810.1,742.3,810,742.1,809.8,741.9L809.8,741.9z"/>
		<path class="st6" d="M809.8,744c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l-0.2,0l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.5-0.1,0.9-0.3,1.2-0.8
			c0.1-0.2,0-0.4-0.1-0.5C809.9,744,809.8,744,809.8,744z"/>
		<path class="st6" d="M809.3,746L809.3,746c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1l-0.3,0l0,0l-0.1,0l0,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C809.6,745.8,809.4,745.9,809.3,746z"/>
		<path class="st6" d="M816.8,746.8c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4l0.1,0
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5l0-0.1
			l0,0l-0.3,0l-0.1,0l0,0l0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5c-0.2,0-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			l0,0c-0.1,0.2-0.4,0.4-0.6,0.5l-1.9-10.7c0-0.2-0.2-0.3-0.3-0.3l-3,0c-0.2,0-0.3,0.1-0.3,0.3l0,0l-0.1,12.3l-4.3,0
			c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3l14,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3l-3.7,0l-0.2-1
			C816.4,747.1,816.7,747,816.8,746.8z M811.7,748.2l-0.7,0l0-1l0.7,0L811.7,748.2z M812.3,748.2l0-1l2,0c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.2-0.1-0.3-0.3-0.3l-2,0l0.1-7c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3l0,0.1l-0.1,7l-0.6,0l0.1-10.4l2.4,0l2.1,12
			L812.3,748.2L812.3,748.2z"/>
	</g>
</g> -->
<g @click="mostarIntervencao(7)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(7)">
	<circle class="st2" cx="365.2" cy="279.7" r="14.5"/>
	<circle class="st3" cx="365.2" cy="279.7" r="13"/>
	<circle class="st4" cx="365.2" cy="279.7" r="11.7"/>
	<path class="st5" d="M365.2,292.1c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C377.6,286.5,372,292.1,365.2,292.1z M365.2,268.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C376.2,273.6,371.3,268.6,365.2,268.6L365.2,268.6z"/>
	<path class="st6" d="M372.7,279.3h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C373,279.4,372.8,279.3,372.7,279.3L372.7,279.3z M365.6,275.4h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L365.6,275.4z M359.2,284.7h-1.4v-4.9h1.4V284.7z M364.5,274.6h0.6v0.3h-0.6
		V274.6z M364.5,275.4h0.6v0.6h-0.6V275.4z M364.5,276.5h0.6v1.7h-0.6V276.5z M363.2,276L363.2,276l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L363.2,276z M363.4,278.7h2.8v1.1h-2.8V278.7z
		 M359.7,280.8h1.8v2.8h-1.8V280.8z M367.6,284.2h-5.5v-3.9h5.5V284.2z M370.6,283.6h-2.5v-2.8h2.5V283.6z M372.5,284.7h-1.4v-4.9
		h1.4V284.7z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(12)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(12)">
	<circle class="st2" cx="468.5" cy="284.7" r="14.5"/>
	<circle class="st3" cx="468.5" cy="284.7" r="13"/>
	<circle class="st4" cx="468.5" cy="284.7" r="11.7"/>
	<path class="st5" d="M468.5,297.1c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C480.9,291.5,475.3,297.1,468.5,297.1z M468.5,273.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C479.5,278.6,474.6,273.6,468.5,273.6L468.5,273.6z"/>
	<path class="st6" d="M476,284.3h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C476.3,284.4,476.1,284.3,476,284.3L476,284.3z M468.9,280.4h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3H469L468.9,280.4z M462.5,289.7h-1.4v-4.9h1.4V289.7z M467.8,279.6h0.6v0.3h-0.6
		V279.6z M467.8,280.4h0.6v0.6h-0.6V280.4z M467.8,281.5h0.6v1.7h-0.6V281.5z M466.5,281L466.5,281l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L466.5,281z M466.7,283.7h2.8v1.1h-2.8V283.7z
		 M463,285.8h1.8v2.8H463V285.8z M470.9,289.2h-5.5v-3.9h5.5V289.2z M473.9,288.6h-2.5v-2.8h2.5V288.6z M475.8,289.7h-1.4v-4.9h1.4
		V289.7z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(14)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(14)">
	<circle class="st2" cx="520.1" cy="295.8" r="14.5"/>
	<circle class="st3" cx="520.1" cy="295.8" r="13"/>
	<circle class="st4" cx="520.1" cy="295.8" r="11.7"/>
	<path class="st5" d="M520.1,308.2c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C532.5,302.6,526.9,308.2,520.1,308.2z M520.1,284.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C531.1,289.7,526.2,284.7,520.1,284.7L520.1,284.7z"/>
	<path class="st6" d="M527.6,295.4h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H523v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0H513c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C527.9,295.5,527.7,295.4,527.6,295.4L527.6,295.4z M520.5,291.5h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L520.5,291.5z M514.1,300.8h-1.4v-4.9h1.4V300.8z M519.4,290.7h0.6v0.3h-0.6
		V290.7z M519.4,291.5h0.6v0.6h-0.6V291.5z M519.4,292.6h0.6v1.7h-0.6V292.6z M518.1,292.1L518.1,292.1l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L518.1,292.1z M518.3,294.8h2.8v1.1h-2.8V294.8z
		 M514.6,296.9h1.8v2.8h-1.8V296.9z M522.5,300.3H517v-3.9h5.5V300.3z M525.5,299.7H523v-2.8h2.5V299.7z M527.4,300.8H526v-4.9h1.4
		V300.8z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(9)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(9)">
	<circle class="st2" cx="554.1" cy="321.4" r="14.5"/>
	<circle class="st3" cx="554.1" cy="321.4" r="13"/>
	<circle class="st4" cx="554.1" cy="321.4" r="11.7"/>
	<path class="st5" d="M554.1,333.8c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C566.5,328.2,560.9,333.8,554.1,333.8z M554.1,310.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C565.1,315.3,560.2,310.3,554.1,310.3L554.1,310.3z"/>
	<path class="st6" d="M561.6,321h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H557v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0H547c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C561.9,321.1,561.7,321,561.6,321L561.6,321z M554.5,317.1h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L554.5,317.1z M548.1,326.4h-1.4v-4.9h1.4V326.4z M553.4,316.3h0.6v0.3h-0.6
		V316.3z M553.4,317.1h0.6v0.6h-0.6V317.1z M553.4,318.2h0.6v1.7h-0.6V318.2z M552.1,317.7L552.1,317.7l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L552.1,317.7z M552.3,320.4h2.8v1.1h-2.8V320.4z
		 M548.6,322.5h1.8v2.8h-1.8V322.5z M556.5,325.9H551V322h5.5V325.9z M559.5,325.3H557v-2.8h2.5V325.3z M561.4,326.4H560v-4.9h1.4
		V326.4z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(13)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(13)">
	<circle class="st2" cx="431.8" cy="392.1" r="14.5"/>
	<circle class="st3" cx="431.8" cy="392.1" r="13"/>
	<circle class="st4" cx="431.8" cy="392.1" r="11.7"/>
	<path class="st5" d="M431.8,404.5c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C444.2,398.9,438.6,404.5,431.8,404.5z M431.8,381c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C442.8,386,437.9,381,431.8,381L431.8,381z"/>
	<path class="st6" d="M439.3,391.7h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8V389h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8v-0.6
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H430l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8V392
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C439.6,391.8,439.4,391.7,439.3,391.7L439.3,391.7z M432.2,387.8h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0H435h-0.1l-1.7-0.3h-0.9L432.2,387.8z M425.8,397.1h-1.4v-4.9h1.4V397.1z M431.1,387h0.6v0.3h-0.6V387
		z M431.1,387.8h0.6v0.6h-0.6V387.8z M431.1,388.9h0.6v1.7h-0.6V388.9z M429.8,388.4L429.8,388.4l-1.7,0.3H428
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L429.8,388.4z M430,391.1h2.8v1.1H430V391.1z
		 M426.3,393.2h1.8v2.8h-1.8V393.2z M434.2,396.6h-5.5v-3.9h5.5V396.6z M437.2,396h-2.5v-2.8h2.5V396z M439.1,397.1h-1.4v-4.9h1.4
		V397.1z"/>
	</v-touch>
</g>
<g  @click="mostarIntervencao(10)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(10)">
	<circle class="st2" cx="464.8" cy="432.3" r="14.5"/>
	<circle class="st3" cx="464.8" cy="432.3" r="13"/>
	<circle class="st4" cx="464.8" cy="432.3" r="11.7"/>
	<path class="st5" d="M464.8,444.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C477.2,439.1,471.6,444.7,464.8,444.7z M464.8,421.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C475.8,426.2,470.9,421.2,464.8,421.2L464.8,421.2z"/>
	<path class="st6" d="M472.3,431.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8V427
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H463l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C472.6,432,472.4,431.9,472.3,431.9L472.3,431.9z M465.2,428h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0H468h-0.1l-1.7-0.3h-0.9L465.2,428z M458.8,437.3h-1.4v-4.9h1.4V437.3z M464.1,427.2h0.6v0.3h-0.6
		V427.2z M464.1,428h0.6v0.6h-0.6V428z M464.1,429.1h0.6v1.7h-0.6V429.1z M462.8,428.6L462.8,428.6l-1.7,0.3H461
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L462.8,428.6z M463,431.3h2.8v1.1H463V431.3z
		 M459.3,433.4h1.8v2.8h-1.8V433.4z M467.2,436.8h-5.5v-3.9h5.5V436.8z M470.2,436.2h-2.5v-2.8h2.5V436.2z M472.1,437.3h-1.4v-4.9
		h1.4V437.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(11)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(11)">
	<circle class="st2" cx="542.4" cy="386.6" r="14.5"/>
	<circle class="st3" cx="542.4" cy="386.6" r="13"/>
	<circle class="st4" cx="542.4" cy="386.6" r="11.7"/>
	<path class="st5" d="M542.4,399c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C554.8,393.4,549.2,399,542.4,399z M542.4,375.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C553.4,380.5,548.5,375.5,542.4,375.5L542.4,375.5z"/>
	<path class="st6" d="M549.9,386.2H548c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5V387c0-0.1-0.1-0.2-0.2-0.2l0,0H544v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0H543v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3H543v-0.6
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3V391h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0V391h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C550.2,386.3,550,386.2,549.9,386.2L549.9,386.2z M542.8,382.3h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L542.8,382.3z M536.4,391.6H535v-4.9h1.4V391.6z M541.7,381.5h0.6v0.3h-0.6
		V381.5z M541.7,382.3h0.6v0.6h-0.6V382.3z M541.7,383.4h0.6v1.7h-0.6V383.4z M540.4,382.9L540.4,382.9l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L540.4,382.9z M540.6,385.6h2.8v1.1h-2.8V385.6z
		 M536.9,387.7h1.8v2.8h-1.8V387.7z M544.8,391.1h-5.5v-3.9h5.5V391.1z M547.8,390.5h-2.5v-2.8h2.5V390.5z M549.7,391.6h-1.4v-4.9
		h1.4V391.6z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(8)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(8)">
	<circle class="st2" cx="446.3" cy="512.3" r="14.5"/>
	<circle class="st3" cx="446.3" cy="512.3" r="13"/>
	<circle class="st4" cx="446.3" cy="512.3" r="11.7"/>
	<path class="st5" d="M446.3,524.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C458.7,519.1,453.1,524.7,446.3,524.7z M446.3,501.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C457.3,506.2,452.4,501.2,446.3,501.2L446.3,501.2z"/>
	<path class="st6" d="M453.8,511.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8V507
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C454.1,512,453.9,511.9,453.8,511.9L453.8,511.9z M446.7,508h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L446.7,508z M440.3,517.3h-1.4v-4.9h1.4V517.3z M445.6,507.2h0.6v0.3h-0.6
		V507.2z M445.6,508h0.6v0.6h-0.6V508z M445.6,509.1h0.6v1.7h-0.6V509.1z M444.3,508.6L444.3,508.6l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L444.3,508.6z M444.5,511.3h2.8v1.1h-2.8V511.3z
		 M440.8,513.4h1.8v2.8h-1.8V513.4z M448.7,516.8h-5.5v-3.9h5.5V516.8z M451.7,516.2h-2.5v-2.8h2.5V516.2z M453.6,517.3h-1.4v-4.9
		h1.4V517.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(41)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(41)">
	<circle class="st2" cx="384" cy="662.9" r="14.5"/>
	<circle class="st3" cx="384" cy="662.9" r="13"/>
	<circle class="st4" cx="384" cy="662.9" r="11.7"/>
	<path class="st5" d="M384,675.3c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C396.4,669.7,390.8,675.3,384,675.3z M384,651.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C395,656.8,390.1,651.8,384,651.8L384,651.8z"/>
	<path class="st6" d="M391.5,662.5h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4H381c-0.1,0-0.2,0.1-0.2,0.2l0,0
		v0.3H379v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3
		v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9
		c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C391.8,662.6,391.6,662.5,391.5,662.5L391.5,662.5z M384.4,658.6h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L384.4,658.6z M378,667.9h-1.4V663h1.4V667.9z
		 M383.3,657.8h0.6v0.3h-0.6V657.8z M383.3,658.6h0.6v0.6h-0.6V658.6z M383.3,659.7h0.6v1.7h-0.6V659.7z M382,659.2L382,659.2
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H382z M382.2,661.9h2.8v1.1h-2.8
		V661.9z M378.5,664h1.8v2.8h-1.8V664z M386.4,667.4h-5.5v-3.9h5.5V667.4z M389.4,666.8h-2.5V664h2.5V666.8z M391.3,667.9h-1.4V663
		h1.4V667.9z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(43)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(43)">
	<circle class="st2" cx="440.3" cy="671.3" r="14.5"/>
	<circle class="st3" cx="440.3" cy="671.3" r="13"/>
	<circle class="st4" cx="440.3" cy="671.3" r="11.7"/>
	<path class="st5" d="M440.3,683.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C452.7,678.1,447.1,683.7,440.3,683.7z M440.3,660.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C451.3,665.2,446.4,660.2,440.3,660.2L440.3,660.2z"/>
	<path class="st6" d="M447.8,670.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8V666c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C448.1,671,447.9,670.9,447.8,670.9L447.8,670.9z M440.7,667h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L440.7,667z M434.3,676.3h-1.4v-4.9h1.4V676.3z
		 M439.6,666.2h0.6v0.3h-0.6V666.2z M439.6,667h0.6v0.6h-0.6V667z M439.6,668.1h0.6v1.7h-0.6V668.1z M438.3,667.6L438.3,667.6
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H438.3z M438.5,670.3h2.8v1.1h-2.8
		V670.3z M434.8,672.4h1.8v2.8h-1.8V672.4z M442.7,675.8h-5.5v-3.9h5.5V675.8z M445.7,675.2h-2.5v-2.8h2.5V675.2z M447.6,676.3h-1.4
		v-4.9h1.4V676.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(38)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(38)">
	<circle class="st2" cx="640.6" cy="635.2" r="14.5"/>
	<circle class="st3" cx="640.6" cy="635.2" r="13"/>
	<circle class="st4" cx="640.6" cy="635.2" r="11.7"/>
	<path class="st5" d="M640.6,647.6c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C653,642,647.4,647.6,640.6,647.6z M640.6,624.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C651.6,629.1,646.7,624.1,640.6,624.1L640.6,624.1z"/>
	<path class="st6" d="M648.1,634.8h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1V634
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0V635C648.4,634.9,648.2,634.8,648.1,634.8L648.1,634.8z M641,630.9h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L641,630.9z M634.6,640.2h-1.4v-4.9h1.4V640.2z
		 M639.9,630.1h0.6v0.3h-0.6V630.1z M639.9,630.9h0.6v0.6h-0.6V630.9z M639.9,632h0.6v1.7h-0.6V632z M638.6,631.5L638.6,631.5
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H638.6z M638.8,634.2h2.8v1.1h-2.8
		V634.2z M635.1,636.3h1.8v2.8h-1.8V636.3z M643,639.7h-5.5v-3.9h5.5V639.7z M646,639.1h-2.5v-2.8h2.5V639.1z M647.9,640.2h-1.4
		v-4.9h1.4V640.2z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(6)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(6)">
	<circle class="st2" cx="480.5" cy="600.2" r="14.5"/>
	<circle class="st3" cx="480.5" cy="600.2" r="13"/>
	<circle class="st4" cx="480.5" cy="600.2" r="11.7"/>
	<path class="st5" d="M480.5,612.6c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C492.9,607,487.3,612.6,480.5,612.6z M480.5,589.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C491.5,594.1,486.6,589.1,480.5,589.1L480.5,589.1z"/>
	<path class="st6" d="M488,599.8h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1V599
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0V600C488.3,599.9,488.1,599.8,488,599.8L488,599.8z M480.9,595.9h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3H481L480.9,595.9z M474.5,605.2h-1.4v-4.9h1.4V605.2z
		 M479.8,595.1h0.6v0.3h-0.6V595.1z M479.8,595.9h0.6v0.6h-0.6V595.9z M479.8,597h0.6v1.7h-0.6V597z M478.5,596.5L478.5,596.5
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H478.5z M478.7,599.2h2.8v1.1h-2.8
		V599.2z M475,601.3h1.8v2.8H475V601.3z M482.9,604.7h-5.5v-3.9h5.5V604.7z M485.9,604.1h-2.5v-2.8h2.5V604.1z M487.8,605.2h-1.4
		v-4.9h1.4V605.2z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(20)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(20)">
	<circle class="st2" cx="573.7" cy="477.5" r="14.5"/>
	<circle class="st3" cx="573.7" cy="477.5" r="13"/>
	<circle class="st4" cx="573.7" cy="477.5" r="11.7"/>
	<path class="st5" d="M573.7,489.9c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C586.1,484.3,580.5,489.9,573.7,489.9z M573.7,466.4c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C584.7,471.4,579.8,466.4,573.7,466.4L573.7,466.4z"/>
	<path class="st6" d="M581.2,477.1h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0H573c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7H572c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C581.5,477.2,581.3,477.1,581.2,477.1L581.2,477.1z M574.1,473.2h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L574.1,473.2z M567.7,482.5h-1.4v-4.9h1.4V482.5z M573,472.4h0.6v0.3H573
		V472.4z M573,473.2h0.6v0.6H573V473.2z M573,474.3h0.6v1.7H573V474.3z M571.7,473.8L571.7,473.8l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L571.7,473.8z M571.9,476.5h2.8v1.1h-2.8V476.5z
		 M568.2,478.6h1.8v2.8h-1.8V478.6z M576.1,482h-5.5v-3.9h5.5V482z M579.1,481.4h-2.5v-2.8h2.5V481.4z M581,482.5h-1.4v-4.9h1.4
		V482.5z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(21)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(21)">
	<circle class="st2" cx="606.1" cy="434.8" r="14.5"/>
	<circle class="st3" cx="606.1" cy="434.8" r="13"/>
	<circle class="st4" cx="606.1" cy="434.8" r="11.7"/>
	<path class="st5" d="M606.1,447.2c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C618.5,441.6,612.9,447.2,606.1,447.2z M606.1,423.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C617.1,428.7,612.2,423.7,606.1,423.7L606.1,423.7z"/>
	<path class="st6" d="M613.6,434.4h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H609v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0H599c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C613.9,434.5,613.7,434.4,613.6,434.4L613.6,434.4z M606.5,430.5h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L606.5,430.5z M600.1,439.8h-1.4v-4.9h1.4V439.8z M605.4,429.7h0.6v0.3h-0.6
		V429.7z M605.4,430.5h0.6v0.6h-0.6V430.5z M605.4,431.6h0.6v1.7h-0.6V431.6z M604.1,431.1L604.1,431.1l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L604.1,431.1z M604.3,433.8h2.8v1.1h-2.8V433.8z
		 M600.6,435.9h1.8v2.8h-1.8V435.9z M608.5,439.3H603v-3.9h5.5V439.3z M611.5,438.7H609v-2.8h2.5V438.7z M613.4,439.8H612v-4.9h1.4
		V439.8z"/>
	</v-touch>
</g>
<g  @click="mostarIntervencao(23)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(23)">
	<circle class="st2" cx="694.8" cy="478.1" r="14.5"/>
	<circle class="st3" cx="694.8" cy="478.1" r="13"/>
	<circle class="st4" cx="694.8" cy="478.1" r="11.7"/>
	<path class="st5" d="M694.8,490.5c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C707.2,484.9,701.6,490.5,694.8,490.5z M694.8,467c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C705.8,472,700.9,467,694.8,467L694.8,467z"/>
	<path class="st6" d="M702.3,477.7h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8V475h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8v-0.6
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H693l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8V478
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C702.6,477.8,702.4,477.7,702.3,477.7L702.3,477.7z M695.2,473.8h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0H698h-0.1l-1.7-0.3h-0.9L695.2,473.8z M688.8,483.1h-1.4v-4.9h1.4V483.1z M694.1,473h0.6v0.3h-0.6V473
		z M694.1,473.8h0.6v0.6h-0.6V473.8z M694.1,474.9h0.6v1.7h-0.6V474.9z M692.8,474.4L692.8,474.4l-1.7,0.3H691
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L692.8,474.4z M693,477.1h2.8v1.1H693V477.1z
		 M689.3,479.2h1.8v2.8h-1.8V479.2z M697.2,482.6h-5.5v-3.9h5.5V482.6z M700.2,482h-2.5v-2.8h2.5V482z M702.1,483.1h-1.4v-4.9h1.4
		V483.1z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(24)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(24)">
	<circle class="st2" cx="668.6" cy="513.4" r="14.5"/>
	<circle class="st3" cx="668.6" cy="513.4" r="13"/>
	<circle class="st4" cx="668.6" cy="513.4" r="11.7"/>
	<path class="st5" d="M668.6,525.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.8,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C681,520.2,675.4,525.8,668.6,525.8z M668.6,502.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C679.6,507.3,674.7,502.3,668.6,502.3L668.6,502.3z"/>
	<path class="st6" d="M676.1,513h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C676.4,513.1,676.2,513,676.1,513L676.1,513z M669,509.1h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L669,509.1z M662.6,518.4h-1.4v-4.9h1.4V518.4z M667.9,508.3h0.6v0.3h-0.6
		V508.3z M667.9,509.1h0.6v0.6h-0.6V509.1z M667.9,510.2h0.6v1.7h-0.6V510.2z M666.6,509.7L666.6,509.7l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L666.6,509.7z M666.8,512.4h2.8v1.1h-2.8V512.4z
		 M663.1,514.5h1.8v2.8h-1.8V514.5z M671,517.9h-5.5V514h5.5V517.9z M674,517.3h-2.5v-2.8h2.5V517.3z M675.9,518.4h-1.4v-4.9h1.4
		V518.4z"/>
	</v-touch>
</g>
<g  @click="mostarIntervencao(31)">
	<circle class="st2" cx="686.8" cy="605.8" r="14.5"/>
	<circle class="st3" cx="686.8" cy="605.8" r="13"/>
	<circle class="st4" cx="686.8" cy="605.8" r="11.7"/>
	<path class="st5" d="M686.8,618.2c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C699.2,612.6,693.6,618.2,686.8,618.2z M686.8,594.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C697.8,599.7,692.9,594.7,686.8,594.7L686.8,594.7z"/>
	<path class="st6" d="M694.3,605.4h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H685l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C694.6,605.5,694.4,605.4,694.3,605.4L694.3,605.4z M687.2,601.5h0.8c0,0,0,0,0.1,0
		l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0H690h-0.1l-1.7-0.3h-0.9L687.2,601.5z M680.8,610.8h-1.4v-4.9h1.4
		V610.8z M686.1,600.7h0.6v0.3h-0.6V600.7z M686.1,601.5h0.6v0.6h-0.6V601.5z M686.1,602.6h0.6v1.7h-0.6V602.6z M684.8,602.1
		L684.8,602.1l-1.7,0.3H683c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H684.8z M685,604.8h2.8
		v1.1H685V604.8z M681.3,606.9h1.8v2.8h-1.8V606.9z M689.2,610.3h-5.5v-3.9h5.5V610.3z M692.2,609.7h-2.5v-2.8h2.5V609.7z
		 M694.1,610.8h-1.4v-4.9h1.4V610.8z"/>
</g>
<g @click="mostarIntervencao(32)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(32)">
	<circle class="st2" cx="733.6" cy="568.9" r="14.5"/>
	<circle class="st3" cx="733.6" cy="568.9" r="13"/>
	<circle class="st4" cx="733.6" cy="568.9" r="11.7"/>
	<path class="st5" d="M733.6,581.3c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C746,575.7,740.4,581.3,733.6,581.3z M733.6,557.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C744.6,562.8,739.7,557.8,733.6,557.8L733.6,557.8z"/>
	<path class="st6" d="M741.1,568.5h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C741.4,568.6,741.2,568.5,741.1,568.5L741.1,568.5z M734,564.6h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L734,564.6z M727.6,573.9h-1.4V569h1.4V573.9z
		 M732.9,563.8h0.6v0.3h-0.6V563.8z M732.9,564.6h0.6v0.6h-0.6V564.6z M732.9,565.7h0.6v1.7h-0.6V565.7z M731.6,565.2L731.6,565.2
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H731.6z M731.8,567.9h2.8v1.1h-2.8
		V567.9z M728.1,570h1.8v2.8h-1.8V570z M736,573.4h-5.5v-3.9h5.5V573.4z M739,572.8h-2.5V570h2.5V572.8z M740.9,573.9h-1.4V569h1.4
		V573.9z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(34)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(34)">
	<circle class="st2" cx="790.8" cy="578.5" r="14.5"/>
	<circle class="st3" cx="790.8" cy="578.5" r="13"/>
	<circle class="st4" cx="790.8" cy="578.5" r="11.7"/>
	<path class="st5" d="M790.8,590.9c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C803.2,585.3,797.6,590.9,790.8,590.9z M790.8,567.4c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C801.8,572.4,796.9,567.4,790.8,567.4L790.8,567.4z"/>
	<path class="st6" d="M798.3,578.1h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H789l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C798.6,578.2,798.4,578.1,798.3,578.1L798.3,578.1z M791.2,574.2h0.8c0,0,0,0,0.1,0
		l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0H794h-0.1l-1.7-0.3h-0.9L791.2,574.2z M784.8,583.5h-1.4v-4.9h1.4
		V583.5z M790.1,573.4h0.6v0.3h-0.6V573.4z M790.1,574.2h0.6v0.6h-0.6V574.2z M790.1,575.3h0.6v1.7h-0.6V575.3z M788.8,574.8
		L788.8,574.8l-1.7,0.3H787c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H788.8z M789,577.5h2.8
		v1.1H789V577.5z M785.3,579.6h1.8v2.8h-1.8V579.6z M793.2,583h-5.5v-3.9h5.5V583z M796.2,582.4h-2.5v-2.8h2.5V582.4z M798.1,583.5
		h-1.4v-4.9h1.4V583.5z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(33)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(33)">
	<circle class="st2" cx="769.6" cy="604.1" r="14.5"/>
	<circle class="st3" cx="769.6" cy="604.1" r="13"/>
	<circle class="st4" cx="769.6" cy="604.1" r="11.7"/>
	<path class="st5" d="M769.6,616.5c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C782,610.9,776.4,616.5,769.6,616.5z M769.6,593c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C780.6,598,775.7,593,769.6,593L769.6,593z"/>
	<path class="st6" d="M777.1,603.7h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8V601h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8V604c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C777.4,603.8,777.2,603.7,777.1,603.7L777.1,603.7z M770,599.8h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L770,599.8z M763.6,609.1h-1.4v-4.9h1.4V609.1z
		 M768.9,599h0.6v0.3h-0.6V599z M768.9,599.8h0.6v0.6h-0.6V599.8z M768.9,600.9h0.6v1.7h-0.6V600.9z M767.6,600.4L767.6,600.4
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H767.6z M767.8,603.1h2.8v1.1h-2.8
		V603.1z M764.1,605.2h1.8v2.8h-1.8V605.2z M772,608.6h-5.5v-3.9h5.5V608.6z M775,608h-2.5v-2.8h2.5V608z M776.9,609.1h-1.4v-4.9
		h1.4V609.1z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(19)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(19)">
	<circle class="st2" cx="823.5" cy="499.3" r="14.5"/>
	<circle class="st3" cx="823.5" cy="499.3" r="13"/>
	<circle class="st4" cx="823.5" cy="499.3" r="11.7"/>
	<path class="st5" d="M823.5,511.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C835.9,506.1,830.3,511.7,823.5,511.7z M823.5,488.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C834.5,493.2,829.6,488.2,823.5,488.2L823.5,488.2z"/>
	<path class="st6" d="M831,498.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8V494
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C831.3,499,831.1,498.9,831,498.9L831,498.9z M823.9,495h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3H824L823.9,495z M817.5,504.3h-1.4v-4.9h1.4V504.3z M822.8,494.2h0.6v0.3h-0.6
		V494.2z M822.8,495h0.6v0.6h-0.6V495z M822.8,496.1h0.6v1.7h-0.6V496.1z M821.5,495.6L821.5,495.6l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L821.5,495.6z M821.7,498.3h2.8v1.1h-2.8V498.3z
		 M818,500.4h1.8v2.8H818V500.4z M825.9,503.8h-5.5v-3.9h5.5V503.8z M828.9,503.2h-2.5v-2.8h2.5V503.2z M830.8,504.3h-1.4v-4.9h1.4
		V504.3z"/>
	</v-touch>
</g>
<g  @click="mostarIntervencao(35)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(35)">
	<circle class="st2" cx="858.9" cy="570" r="14.5"/>
	<circle class="st3" cx="858.9" cy="570" r="13"/>
	<circle class="st4" cx="858.9" cy="570" r="11.7"/>
	<path class="st5" d="M858.9,582.4c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C871.3,576.8,865.7,582.4,858.9,582.4z M858.9,558.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C869.9,563.9,865,558.9,858.9,558.9L858.9,558.9z"/>
	<path class="st6" d="M866.4,569.6h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C866.7,569.7,866.5,569.6,866.4,569.6L866.4,569.6z M859.3,565.7h0.8c0,0,0,0,0.1,0
		l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1H862l-1.7-0.3h-0.9L859.3,565.7z M852.9,575h-1.4v-4.9h1.4V575z
		 M858.2,564.9h0.6v0.3h-0.6V564.9z M858.2,565.7h0.6v0.6h-0.6V565.7z M858.2,566.8h0.6v1.7h-0.6V566.8z M856.9,566.3L856.9,566.3
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H856.9z M857.1,569h2.8v1.1h-2.8
		V569z M853.4,571.1h1.8v2.8h-1.8V571.1z M861.3,574.5h-5.5v-3.9h5.5V574.5z M864.3,573.9h-2.5v-2.8h2.5V573.9z M866.2,575h-1.4
		v-4.9h1.4V575z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(54)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(54)">
	<circle class="st2" cx="859.2" cy="646.3" r="14.5"/>
	<circle class="st3" cx="859.2" cy="646.3" r="13"/>
	<circle class="st4" cx="859.2" cy="646.3" r="11.7"/>
	<path class="st5" d="M859.2,658.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C871.6,653.1,866,658.7,859.2,658.7z M859.2,635.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C870.2,640.2,865.3,635.2,859.2,635.2L859.2,635.2z"/>
	<path class="st6" d="M866.7,645.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8V641c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C867,646,866.8,645.9,866.7,645.9L866.7,645.9z M859.6,642h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L859.6,642z M853.2,651.3h-1.4v-4.9h1.4V651.3z
		 M858.5,641.2h0.6v0.3h-0.6V641.2z M858.5,642h0.6v0.6h-0.6V642z M858.5,643.1h0.6v1.7h-0.6V643.1z M857.2,642.6L857.2,642.6
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H857.2z M857.4,645.3h2.8v1.1h-2.8
		V645.3z M853.7,647.4h1.8v2.8h-1.8V647.4z M861.6,650.8h-5.5v-3.9h5.5V650.8z M864.6,650.2h-2.5v-2.8h2.5V650.2z M866.5,651.3h-1.4
		v-4.9h1.4V651.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(58)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(58)">
	<circle class="st2" cx="816.1" cy="680.3" r="14.5"/>
	<circle class="st3" cx="816.1" cy="680.3" r="13"/>
	<circle class="st4" cx="816.1" cy="680.3" r="11.7"/>
	<path class="st5" d="M816.1,692.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C828.5,687.1,822.9,692.7,816.1,692.7z M816.1,669.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C827.1,674.2,822.2,669.2,816.1,669.2L816.1,669.2z"/>
	<path class="st6" d="M823.6,679.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H819v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8V675c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0H809c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C823.9,680,823.7,679.9,823.6,679.9L823.6,679.9z M816.5,676h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L816.5,676z M810.1,685.3h-1.4v-4.9h1.4V685.3z
		 M815.4,675.2h0.6v0.3h-0.6V675.2z M815.4,676h0.6v0.6h-0.6V676z M815.4,677.1h0.6v1.7h-0.6V677.1z M814.1,676.6L814.1,676.6
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H814.1z M814.3,679.3h2.8v1.1h-2.8
		V679.3z M810.6,681.4h1.8v2.8h-1.8V681.4z M818.5,684.8H813v-3.9h5.5V684.8z M821.5,684.2H819v-2.8h2.5V684.2z M823.4,685.3H822
		v-4.9h1.4V685.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(40)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(40)">
	<circle class="st2" cx="801.5" cy="711.1" r="14.5"/>
	<circle class="st3" cx="801.5" cy="711.1" r="13"/>
	<circle class="st4" cx="801.5" cy="711.1" r="11.7"/>
	<path class="st5" d="M801.5,723.5c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C813.9,717.9,808.3,723.5,801.5,723.5z M801.5,700c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C812.5,705,807.6,700,801.5,700L801.5,700z"/>
	<path class="st6" d="M809,710.7h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8V708h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8V711c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C809.3,710.8,809.1,710.7,809,710.7L809,710.7z M801.9,706.8h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3H802L801.9,706.8z M795.5,716.1h-1.4v-4.9h1.4V716.1z
		 M800.8,706h0.6v0.3h-0.6V706z M800.8,706.8h0.6v0.6h-0.6V706.8z M800.8,707.9h0.6v1.7h-0.6V707.9z M799.5,707.4L799.5,707.4
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H799.5z M799.7,710.1h2.8v1.1h-2.8
		V710.1z M796,712.2h1.8v2.8H796V712.2z M803.9,715.6h-5.5v-3.9h5.5V715.6z M806.9,715h-2.5v-2.8h2.5V715z M808.8,716.1h-1.4v-4.9
		h1.4V716.1z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(47)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(47)">
	<circle class="st2" cx="758.5" cy="689.5" r="14.5"/>
	<circle class="st3" cx="758.5" cy="689.5" r="13"/>
	<circle class="st4" cx="758.5" cy="689.5" r="11.7"/>
	<path class="st5" d="M758.5,701.9c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C770.9,696.3,765.3,701.9,758.5,701.9z M758.5,678.4c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C769.5,683.4,764.6,678.4,758.5,678.4L758.5,678.4z"/>
	<path class="st6" d="M766,689.1h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C766.3,689.2,766.1,689.1,766,689.1L766,689.1z M758.9,685.2h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3H759L758.9,685.2z M752.5,694.5h-1.4v-4.9h1.4V694.5z
		 M757.8,684.4h0.6v0.3h-0.6V684.4z M757.8,685.2h0.6v0.6h-0.6V685.2z M757.8,686.3h0.6v1.7h-0.6V686.3z M756.5,685.8L756.5,685.8
		l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H756.5z M756.7,688.5h2.8v1.1h-2.8
		V688.5z M753,690.6h1.8v2.8H753V690.6z M760.9,694h-5.5v-3.9h5.5V694z M763.9,693.4h-2.5v-2.8h2.5V693.4z M765.8,694.5h-1.4v-4.9
		h1.4V694.5z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(52)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(52)">
	<circle class="st2" cx="793.7" cy="661.8" r="14.5"/>
	<circle class="st3" cx="793.7" cy="661.8" r="13"/>
	<circle class="st4" cx="793.7" cy="661.8" r="11.7"/>
	<path class="st5" d="M793.7,674.2c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C806.1,668.6,800.5,674.2,793.7,674.2z M793.7,650.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C804.7,655.7,799.8,650.7,793.7,650.7L793.7,650.7z"/>
	<path class="st6" d="M801.2,661.4h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0H793c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7H792c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0
		v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3
		v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9
		c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C801.5,661.5,801.3,661.4,801.2,661.4L801.2,661.4z M794.1,657.5h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L794.1,657.5z M787.7,666.8h-1.4v-4.9h1.4V666.8z
		 M793,656.7h0.6v0.3H793V656.7z M793,657.5h0.6v0.6H793V657.5z M793,658.6h0.6v1.7H793V658.6z M791.7,658.1L791.7,658.1l-1.7,0.3
		h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H791.7z M791.9,660.8h2.8v1.1h-2.8V660.8z
		 M788.2,662.9h1.8v2.8h-1.8V662.9z M796.1,666.3h-5.5v-3.9h5.5V666.3z M799.1,665.7h-2.5v-2.8h2.5V665.7z M801,666.8h-1.4v-4.9h1.4
		V666.8z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(48)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(48)">
	<circle class="st2" cx="856" cy="719.2" r="14.5"/>
	<circle class="st3" cx="856" cy="719.2" r="13"/>
	<circle class="st4" cx="856" cy="719.2" r="11.7"/>
	<path class="st5" d="M856,731.6c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C868.4,726,862.8,731.6,856,731.6z M856,708.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C867,713.1,862.1,708.1,856,708.1L856,708.1z"/>
	<path class="st6" d="M863.5,718.8h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1V718
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4H853c-0.1,0-0.2,0.1-0.2,0.2l0,0
		v0.3H851v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3
		v-0.9h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9
		c0.1,0,0.2-0.1,0.2-0.2l0,0V719C863.8,718.9,863.6,718.8,863.5,718.8L863.5,718.8z M856.4,714.9h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L856.4,714.9z M850,724.2h-1.4v-4.9h1.4V724.2z
		 M855.3,714.1h0.6v0.3h-0.6V714.1z M855.3,714.9h0.6v0.6h-0.6V714.9z M855.3,716h0.6v1.7h-0.6V716z M854,715.5L854,715.5l-1.7,0.3
		h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H854z M854.2,718.2h2.8v1.1h-2.8V718.2z
		 M850.5,720.3h1.8v2.8h-1.8V720.3z M858.4,723.7h-5.5v-3.9h5.5V723.7z M861.4,723.1h-2.5v-2.8h2.5V723.1z M863.3,724.2h-1.4v-4.9
		h1.4V724.2z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(2)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(2)">
	<circle class="st2" cx="372.9" cy="445.3" r="14.5"/>
	<circle class="st3" cx="372.9" cy="445.3" r="13"/>
	<circle class="st4" cx="372.9" cy="445.3" r="11.7"/>
	<g>
		<path class="st5" d="M372.9,457.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C385.3,452.2,379.8,457.8,372.9,457.8z M372.9,434.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C384,439.2,379,434.3,372.9,434.3L372.9,434.3z"/>
		<g>
			<path class="st6" d="M376.6,443.6c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C376.8,444,376.8,443.8,376.6,443.6z"/>
			<path class="st6" d="M368.7,441.9c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2,0s0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0s0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C368.6,441.4,368.6,441.7,368.7,441.9L368.7,441.9z"/>
			<path class="st6" d="M380,440.1h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C380.6,440.4,380.3,440.1,380,440.1z M379.8,449.7H379l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4V449.7L379.8,449.7z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(3)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(3)">
	<circle class="st2" cx="516.7" cy="411.7" r="14.5"/>
	<circle class="st3" cx="516.7" cy="411.7" r="13"/>
	<circle class="st4" cx="516.7" cy="411.7" r="11.7"/>
	<g>
		<path class="st5" d="M516.7,424.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C529.1,418.6,523.6,424.2,516.7,424.2z M516.7,400.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1l0,0
			C527.8,405.6,522.8,400.7,516.7,400.7L516.7,400.7z"/>
		<g>
			<path class="st6" d="M520.4,410c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C520.6,410.4,520.6,410.2,520.4,410z"/>
			<path class="st6" d="M512.5,408.3c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C512.4,407.8,512.4,408.1,512.5,408.3L512.5,408.3z"/>
			<path class="st6" d="M523.8,406.5h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C524.4,406.8,524.1,406.5,523.8,406.5z M523.6,416.1h-0.8l0,0H512l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L523.6,416.1L523.6,416.1z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(5)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(5)">
	<circle class="st2" cx="595" cy="360.1" r="14.5"/>
	<circle class="st3" cx="595" cy="360.1" r="13"/>
	<circle class="st4" cx="595" cy="360.1" r="11.7"/>
	<g>
		<path class="st5" d="M595,372.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C607.4,367,601.9,372.6,595,372.6z M595,349.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C606.1,354,601.1,349.1,595,349.1L595,349.1z"/>
		<g>
			<path class="st6" d="M598.7,358.4c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C598.9,358.8,598.9,358.6,598.7,358.4z"/>
			<path class="st6" d="M590.8,356.7c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C590.7,356.2,590.7,356.5,590.8,356.7L590.8,356.7z"/>
			<path class="st6" d="M602.1,354.9h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C602.7,355.2,602.4,354.9,602.1,354.9z M601.9,364.5h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L601.9,364.5L601.9,364.5z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(30)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(30)">
	<circle class="st2" cx="527.8" cy="617.2" r="14.5"/>
	<circle class="st3" cx="527.8" cy="617.2" r="13"/>
	<circle class="st4" cx="527.8" cy="617.2" r="11.7"/>
	<g>
		<path class="st5" d="M527.8,629.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C540.2,624.1,534.7,629.7,527.8,629.7z M527.8,606.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C538.9,611.1,533.9,606.2,527.8,606.2L527.8,606.2z"/>
		<g>
			<path class="st6" d="M531.5,615.5c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C531.7,615.9,531.7,615.7,531.5,615.5z"/>
			<path class="st6" d="M523.6,613.8c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C523.5,613.3,523.5,613.6,523.6,613.8L523.6,613.8z"/>
			<path class="st6" d="M534.9,612H534c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4l-2-5.4
				c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3c0.3,0,0.6-0.3,0.6-0.6
				v-9.3C535.5,612.3,535.2,612,534.9,612z M534.7,621.6h-0.8l0,0h-10.8l0,0H521v-8.8h0.4l2,5.4c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0
				c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L534.7,621.6L534.7,621.6z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(1)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(1)">
	<circle class="st2" cx="493.4" cy="627.6" r="14.5"/>
	<circle class="st3" cx="493.4" cy="627.6" r="13"/>
	<circle class="st4" cx="493.4" cy="627.6" r="11.7"/>
	<g>
		<path class="st5" d="M493.4,640.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C505.8,634.5,500.3,640.1,493.4,640.1z M493.4,616.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C504.5,621.5,499.5,616.6,493.4,616.6L493.4,616.6z"/>
		<g>
			<path class="st6" d="M497.1,625.9c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C497.3,626.3,497.3,626.1,497.1,625.9z"/>
			<path class="st6" d="M489.2,624.2c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2,0s0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0s0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C489.1,623.7,489.1,624,489.2,624.2L489.2,624.2z"/>
			<path class="st6" d="M500.5,622.4h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C501.1,622.7,500.8,622.4,500.5,622.4z M500.3,632h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4V632L500.3,632z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(4)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(4)">
	<circle class="st2" cx="573.7" cy="392" r="14.5"/>
	<circle class="st3" cx="573.7" cy="392" r="13"/>
	<circle class="st4" cx="573.7" cy="392" r="11.7"/>
	<g>
		<path class="st5" d="M573.7,404.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C586.1,398.9,580.6,404.5,573.7,404.5z M573.7,381c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C584.8,385.9,579.8,381,573.7,381L573.7,381z"/>
		<g>
			<path class="st6" d="M577.4,390.3c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C577.6,390.7,577.6,390.5,577.4,390.3z"/>
			<path class="st6" d="M569.5,388.6c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C569.4,388.1,569.4,388.4,569.5,388.6L569.5,388.6z"/>
			<path class="st6" d="M580.8,386.8h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C581.4,387.1,581.1,386.8,580.8,386.8z M580.6,396.4h-0.8l0,0H569l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L580.6,396.4L580.6,396.4z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(25)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(25)">
	<circle class="st2" cx="546.5" cy="509.3" r="14.5"/>
	<circle class="st3" cx="546.5" cy="509.3" r="13"/>
	<circle class="st4" cx="546.5" cy="509.3" r="11.7"/>
	<g>
		<path class="st5" d="M546.5,521.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C558.9,516.2,553.4,521.8,546.5,521.8z M546.5,498.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C557.6,503.2,552.6,498.3,546.5,498.3L546.5,498.3z"/>
		<g>
			<path class="st6" d="M550.2,507.6c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C550.4,508,550.4,507.8,550.2,507.6z"/>
			<path class="st6" d="M542.3,505.9c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C542.2,505.4,542.2,505.7,542.3,505.9L542.3,505.9z"/>
			<path class="st6" d="M553.6,504.1h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C554.2,504.4,553.9,504.1,553.6,504.1z M553.4,513.7h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L553.4,513.7L553.4,513.7z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(36)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(36)">
	<circle class="st2" cx="521" cy="548.5" r="14.5"/>
	<circle class="st3" cx="521" cy="548.5" r="13"/>
	<circle class="st4" cx="521" cy="548.5" r="11.7"/>
	<g>
		<path class="st5" d="M521,561c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C533.4,555.4,527.9,561,521,561z M521,537.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C532.1,542.4,527.1,537.5,521,537.5L521,537.5z"/>
		<g>
			<path class="st6" d="M524.7,546.8c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C524.9,547.2,524.9,547,524.7,546.8z"/>
			<path class="st6" d="M516.8,545.1c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C516.7,544.6,516.7,544.9,516.8,545.1L516.8,545.1z"/>
			<path class="st6" d="M528.1,543.3h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6V544C528.7,543.6,528.4,543.3,528.1,543.3z M527.9,552.9h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L527.9,552.9L527.9,552.9z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(39)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(39)">
	<circle class="st2" cx="500.3" cy="504.1" r="14.5"/>
	<circle class="st3" cx="500.3" cy="504.1" r="13"/>
	<circle class="st4" cx="500.3" cy="504.1" r="11.7"/>
	<g>
		<path class="st5" d="M500.3,516.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C512.7,511,507.2,516.6,500.3,516.6z M500.3,493.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C511.4,498,506.4,493.1,500.3,493.1L500.3,493.1z"/>
		<g>
			<path class="st6" d="M504,502.4c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C504.2,502.8,504.2,502.6,504,502.4z"/>
			<path class="st6" d="M496.1,500.7c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2,0s0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0s0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C496,500.2,496,500.5,496.1,500.7L496.1,500.7z"/>
			<path class="st6" d="M507.4,498.9h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C508,499.2,507.7,498.9,507.4,498.9z M507.2,508.5h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4V508.5L507.2,508.5z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(29)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(29)">
	<circle class="st2" cx="827.2" cy="574.1" r="14.5"/>
	<circle class="st3" cx="827.2" cy="574.1" r="13"/>
	<circle class="st4" cx="827.2" cy="574.1" r="11.7"/>
	<g>
		<path class="st5" d="M827.2,586.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C839.6,581,834.1,586.6,827.2,586.6z M827.2,563.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C838.3,568,833.3,563.1,827.2,563.1L827.2,563.1z"/>
		<g>
			<path class="st6" d="M830.9,572.4c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C831.1,572.8,831.1,572.6,830.9,572.4z"/>
			<path class="st6" d="M823,570.7c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C822.9,570.2,822.9,570.5,823,570.7L823,570.7z"/>
			<path class="st6" d="M834.3,568.9h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5H824c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C834.9,569.2,834.6,568.9,834.3,568.9z M834.1,578.5h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L834.1,578.5L834.1,578.5z"/>
		</g>
	</g>
	</v-touch>
</g>
<g  @click="mostarIntervencao(28)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(28)">
	<circle class="st2" cx="825.9" cy="604.2" r="14.5"/>
	<circle class="st3" cx="825.9" cy="604.2" r="13"/>
	<circle class="st4" cx="825.9" cy="604.2" r="11.7"/>
	<g>
		<path class="st5" d="M825.9,616.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C838.3,611.1,832.8,616.7,825.9,616.7z M825.9,593.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C837,598.1,832,593.2,825.9,593.2L825.9,593.2z"/>
		<g>
			<path class="st6" d="M829.6,602.5c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C829.8,602.9,829.8,602.7,829.6,602.5z"/>
			<path class="st6" d="M821.7,600.8c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C821.6,600.3,821.6,600.6,821.7,600.8L821.7,600.8z"/>
			<path class="st6" d="M833,599h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4l-2-5.4
				c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3c0.3,0,0.6-0.3,0.6-0.6
				v-9.3C833.6,599.3,833.3,599,833,599z M832.8,608.6H832l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0
				c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L832.8,608.6L832.8,608.6z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(46)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(46)">
	<circle class="st2" cx="682.4" cy="684.2" r="14.5"/>
	<circle class="st3" cx="682.4" cy="684.2" r="13"/>
	<circle class="st4" cx="682.4" cy="684.2" r="11.7"/>
	<g>
		<path class="st5" d="M682.4,696.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C694.8,691.1,689.3,696.7,682.4,696.7z M682.4,673.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C693.5,678.1,688.5,673.2,682.4,673.2L682.4,673.2z"/>
		<g>
			<path class="st6" d="M686.1,682.5c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C686.3,682.9,686.3,682.7,686.1,682.5z"/>
			<path class="st6" d="M678.2,680.8c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C678.1,680.3,678.1,680.6,678.2,680.8L678.2,680.8z"/>
			<path class="st6" d="M689.5,679h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C690.1,679.3,689.8,679,689.5,679z M689.3,688.6h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L689.3,688.6L689.3,688.6z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(42)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(42)">
	<circle class="st2" cx="358.4" cy="709.2" r="14.5"/>
	<circle class="st3" cx="358.4" cy="709.2" r="13"/>
	<circle class="st4" cx="358.4" cy="709.2" r="11.7"/>
	<g>
		<path class="st5" d="M358.4,721.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C370.8,716.1,365.3,721.7,358.4,721.7z M358.4,698.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C369.5,703.1,364.5,698.2,358.4,698.2L358.4,698.2z"/>
		<g>
			<path class="st6" d="M362.1,707.5c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C362.3,707.9,362.3,707.7,362.1,707.5z"/>
			<path class="st6" d="M354.2,705.8c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2,0s0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0s0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C354.1,705.3,354.1,705.6,354.2,705.8L354.2,705.8z"/>
			<path class="st6" d="M365.5,704h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C366.1,704.3,365.8,704,365.5,704z M365.3,713.6h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4V713.6L365.3,713.6z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(44)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(44)">
	<circle class="st2" cx="470.3" cy="667.5" r="14.5"/>
	<circle class="st3" cx="470.3" cy="667.5" r="13"/>
	<circle class="st4" cx="470.3" cy="667.5" r="11.7"/>
	<g>
		<path class="st5" d="M470.3,680c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C482.7,674.4,477.2,680,470.3,680z M470.3,656.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C481.4,661.4,476.4,656.5,470.3,656.5L470.3,656.5z"/>
		<g>
			<path class="st6" d="M474,665.8c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C474.2,666.2,474.2,666,474,665.8z"/>
			<path class="st6" d="M466.1,664.1c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2,0s0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0s0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C466,663.6,466,663.9,466.1,664.1L466.1,664.1z"/>
			<path class="st6" d="M477.4,662.3h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6V663C478,662.6,477.7,662.3,477.4,662.3z M477.2,671.9h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4V671.9L477.2,671.9z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(45)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(45)">
	<circle class="st2" cx="493.5" cy="683.6" r="14.5"/>
	<circle class="st3" cx="493.5" cy="683.6" r="13"/>
	<circle class="st4" cx="493.5" cy="683.6" r="11.7"/>
	<g>
		<path class="st5" d="M493.5,696.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C505.9,690.5,500.4,696.1,493.5,696.1z M493.5,672.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C504.6,677.5,499.6,672.6,493.5,672.6L493.5,672.6z"/>
		<g>
			<path class="st6" d="M497.2,681.9c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C497.4,682.3,497.4,682.1,497.2,681.9z"/>
			<path class="st6" d="M489.3,680.2c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2,0s0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0s0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C489.2,679.7,489.2,680,489.3,680.2L489.3,680.2z"/>
			<path class="st6" d="M500.6,678.4h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C501.2,678.7,500.9,678.4,500.6,678.4z M500.4,688h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4V688L500.4,688z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(17)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(17)">
	<circle class="st2" cx="471" cy="364.5" r="14.5"/>
	<circle class="st3" cx="471" cy="364.5" r="13"/>
	<circle class="st4" cx="471" cy="364.5" r="11.7"/>
	<path class="st5" d="M471,376.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C483.4,371.4,477.9,376.9,471,376.9z M471,353.4c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C482.1,358.4,477.1,353.4,471,353.4L471,353.4z"/>
	<path class="st6" d="M471,364.5L471,364.5L471,364.5z"/>
	<g>
		<g>
			<g>
				<path d="M475,359.4h-1.2v-0.5c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C476.3,360,475.7,359.4,475,359.4z
					 M468.9,359.3h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					L468.9,359.3L468.9,359.3z M475.7,370.1c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V360h1.2c0.4,0,0.7,0.3,0.7,0.7V370.1L475.7,370.1z"/>
				<path d="M469.7,364.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C469.9,365.3,469.9,365.1,469.7,364.9C469.7,365,469.7,364.9,469.7,364.9z"/>
				<path d="M474.4,365.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C474.7,365.8,474.6,365.6,474.4,365.6z"/>
				<path d="M469.7,362.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.4c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C469.9,362.7,469.9,362.5,469.7,362.3L469.7,362.3z"/>
				<path d="M474.4,363h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C474.7,363.2,474.6,363,474.4,363z"/>
				<path d="M469.7,367.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C469.9,367.9,469.9,367.7,469.7,367.6L469.7,367.6z"/>
				<path d="M474.4,368.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S474.6,368.3,474.4,368.3z"
					/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(55)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(55)">
	<circle class="st2" cx="873.7" cy="668" r="14.5"/>
	<circle class="st3" cx="873.7" cy="668" r="13"/>
	<circle class="st4" cx="873.7" cy="668" r="11.7"/>
	<path class="st5" d="M873.7,680.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C886.1,674.9,880.6,680.4,873.7,680.4z M873.7,656.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C884.8,661.9,879.8,656.9,873.7,656.9L873.7,656.9z"/>
	<path class="st6" d="M873.7,668L873.7,668L873.7,668z"/>
	<g>
		<g>
			<g>
				<path d="M877.7,662.9h-1.2v-0.5c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C879,663.5,878.4,662.9,877.7,662.9z M871.6,662.8h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L871.6,662.8L871.6,662.8z M878.4,673.6c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L878.4,673.6L878.4,673.6z"/>
				<path d="M872.4,668.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C872.6,668.8,872.6,668.6,872.4,668.4
					C872.4,668.5,872.4,668.4,872.4,668.4z"/>
				<path d="M877.1,669.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C877.4,669.3,877.3,669.1,877.1,669.1z"/>
				<path d="M872.4,665.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.4c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C872.6,666.2,872.6,666,872.4,665.8L872.4,665.8z"/>
				<path d="M877.1,666.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C877.4,666.7,877.3,666.5,877.1,666.5z"/>
				<path d="M872.4,671.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C872.6,671.4,872.6,671.2,872.4,671.1L872.4,671.1z"/>
				<path d="M877.1,671.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C877.4,671.9,877.3,671.8,877.1,671.8z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(37)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(37)">
	<circle class="st2" cx="859.1" cy="595.2" r="14.5"/>
	<circle class="st3" cx="859.1" cy="595.2" r="13"/>
	<circle class="st4" cx="859.1" cy="595.2" r="11.7"/>
	<path class="st5" d="M859.1,607.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C871.5,602.1,866,607.6,859.1,607.6z M859.1,584.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C870.2,589.1,865.2,584.1,859.1,584.1L859.1,584.1z"/>
	<path class="st6" d="M859.1,595.2L859.1,595.2L859.1,595.2z"/>
	<g>
		<g>
			<g>
				<path d="M863.1,590.1h-1.2v-0.5c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6H855c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C864.4,590.7,863.8,590.1,863.1,590.1z M857,590h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H857V590L857,590z M863.8,600.8c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L863.8,600.8
					L863.8,600.8z"/>
				<path d="M857.8,595.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C858,596,858,595.8,857.8,595.6C857.8,595.7,857.8,595.6,857.8,595.6z"/>
				<path d="M862.5,596.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C862.8,596.5,862.7,596.3,862.5,596.3z"/>
				<path d="M857.8,593c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.4c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C858,593.4,858,593.2,857.8,593L857.8,593z"/>
				<path d="M862.5,593.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C862.8,593.9,862.7,593.7,862.5,593.7z"/>
				<path d="M857.8,598.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C858,598.6,858,598.4,857.8,598.3L857.8,598.3z"/>
				<path d="M862.5,599h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S862.7,599,862.5,599z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(26)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(26)">
	<circle class="st2" cx="826.4" cy="447.8" r="14.5"/>
	<circle class="st3" cx="826.4" cy="447.8" r="13"/>
	<circle class="st4" cx="826.4" cy="447.8" r="11.7"/>
	<path class="st5" d="M826.4,460.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C838.8,454.7,833.3,460.2,826.4,460.2z M826.4,436.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C837.5,441.7,832.5,436.7,826.4,436.7L826.4,436.7z"/>
	<path class="st6" d="M826.4,447.8L826.4,447.8L826.4,447.8z"/>
	<g>
		<g>
			<g>
				<path d="M830.4,442.7h-1.2v-0.5c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C831.7,443.3,831.1,442.7,830.4,442.7z M824.3,442.6h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L824.3,442.6L824.3,442.6z M831.1,453.4c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					V444c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L831.1,453.4L831.1,453.4z"/>
				<path d="M825.1,448.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C825.3,448.6,825.3,448.4,825.1,448.2
					C825.1,448.3,825.1,448.2,825.1,448.2z"/>
				<path d="M829.8,448.9H826c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C830.1,449.1,830,448.9,829.8,448.9z"/>
				<path d="M825.1,445.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.4c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C825.3,446,825.3,445.8,825.1,445.6L825.1,445.6z"/>
				<path d="M829.8,446.3H826c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C830.1,446.5,830,446.3,829.8,446.3z"/>
				<path d="M825.1,450.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C825.3,451.2,825.3,451,825.1,450.9L825.1,450.9z"/>
				<path d="M829.8,451.6H826c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S830,451.6,829.8,451.6z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(16)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(16)">
	<circle class="st2" cx="497.5" cy="276.5" r="14.5"/>
	<circle class="st3" cx="497.5" cy="276.5" r="13"/>
	<circle class="st4" cx="497.5" cy="276.5" r="11.7"/>
	<path class="st5" d="M497.5,288.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C509.9,283.4,504.4,288.9,497.5,288.9z M497.5,265.4c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C508.6,270.4,503.6,265.4,497.5,265.4L497.5,265.4z"/>
	<path class="st6" d="M497.5,276.5L497.5,276.5L497.5,276.5z"/>
	<g>
		<g>
			<g>
				<path d="M501.5,271.4h-1.2v-0.5c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1H495
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C502.8,272,502.2,271.4,501.5,271.4z M495.4,271.3h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L495.4,271.3L495.4,271.3z M502.2,282.1c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V272h1.2c0.4,0,0.7,0.3,0.7,0.7V282.1
					L502.2,282.1z"/>
				<path d="M496.2,276.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C496.4,277.3,496.4,277.1,496.2,276.9C496.2,277,496.2,276.9,496.2,276.9z"/>
				<path d="M500.9,277.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C501.2,277.8,501.1,277.6,500.9,277.6z"/>
				<path d="M496.2,274.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.4c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C496.4,274.7,496.4,274.5,496.2,274.3L496.2,274.3z"/>
				<path d="M500.9,275h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C501.2,275.2,501.1,275,500.9,275z"/>
				<path d="M496.2,279.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C496.4,279.9,496.4,279.7,496.2,279.6L496.2,279.6z"/>
				<path d="M500.9,280.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S501.1,280.3,500.9,280.3z"
					/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(51)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(51)">
	<circle class="st2" cx="772" cy="727.9" r="14.5"/>
	<circle class="st3" cx="772" cy="727.9" r="13"/>
	<circle class="st4" cx="772" cy="727.9" r="11.7"/>
	<path class="st5" d="M772,740.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C784.4,734.8,778.9,740.3,772,740.3z M772,716.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C783.1,721.8,778.1,716.8,772,716.8L772,716.8z"/>
	<path class="st6" d="M772,727.9L772,727.9L772,727.9z"/>
	<g>
		<g>
			<g>
				<path d="M776,722.8h-1.2v-0.5c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C777.3,723.4,776.7,722.8,776,722.8z
					 M769.9,722.7h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					L769.9,722.7L769.9,722.7z M776.7,733.5c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L776.7,733.5L776.7,733.5z"/>
				<path d="M770.7,728.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C770.9,728.7,770.9,728.5,770.7,728.3
					C770.7,728.4,770.7,728.3,770.7,728.3z"/>
				<path d="M775.4,729h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3C775.7,729.2,775.6,729,775.4,729z"
					/>
				<path d="M770.7,725.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.4c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C770.9,726.1,770.9,725.9,770.7,725.7L770.7,725.7z"/>
				<path d="M775.4,726.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C775.7,726.6,775.6,726.4,775.4,726.4z"/>
				<path d="M770.7,731c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C770.9,731.3,770.9,731.1,770.7,731L770.7,731z"/>
				<path d="M775.4,731.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S775.6,731.7,775.4,731.7z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
</svg>

         </SvgPanZoom>
      </div>
    </div>
  </div>
</template>


<script>
import SvgPanZoom from 'vue-svg-pan-zoom';
import { mapActions } from 'vuex'
import Modal from '@/components/ModalMapas.vue'

export default {
	components: { SvgPanZoom, Modal },

	data () {
		return {
				informacoes: [
						{
							id: 1,
							titulo: 'CAC-Trecho I (Cinturão das Águas do Ceará)',
							desc: 'Abastecimento humano e usos múltiplos nas bacias do Salgado, Alto, Médio e Baixo Jaguaribe, Metropolitana, RM Fortaleza e Complexo Industrial e Portuário do Pecém',
							estagio: 'Obra',
							valor: 'R$ 1.117,76 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-001_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 2,
							titulo: 'CAC-Trecho II, Trecho III e Ramais 1, 2, Leste e Oeste',
							desc: 'Usos múltiplos em cerca de 54 municípios nas bacias do Alto Jaguaribe, Poti, Banabuiú, Acaraú, Coreaú e Curu',
							estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
							valor: 'R$ 18,50 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 3,
							titulo: 'Eixão das Águas (duplicação)',
							desc: 'Abastecimento humano, dessedentação animal, irrigação e uso industrial na bacia Metropolitana, RM de Fortaleza e Complexo Industrial e Portuário do Pecém',
							estagio: 'Obra',
							valor: 'R$ 878,94 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-004_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 4,
							titulo: 'Eixo de Integração rio Quixeré-Bom Sucesso',
							desc: 'Abastecimento humano, irrigação e dessedentação animal em Quixeré, Limoeiro do Norte e Tabuleiro do Norte',
							estagio: 'Anteprojeto',
							valor: 'R$ 912,51 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-005_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 5,
							titulo: 'Eixo de Integração Jaguaribe-Icapuí',
							desc: 'Abastecimento humano, irrigação, dessedentação animal e uso industrial em Icapuí, e distritos dos municípios de Jaguaruana e Aracati',
							estagio: 'Projeto Básico',
							valor: 'R$ 130,54 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-007_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 6,
							titulo: 'Sistema Adutor Crajubar (Projeto Malha d’Água)',
							desc: 'Abastecimento humano de Crato, Juazeiro do Norte, Barbalha, Missão Velha e Caririaçu',
							estagio: 'EVTEA',
							valor: 'R$ 1,46 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-017aa_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 7,
							titulo: 'Eixo de Integração Taquara-Jaibaras e Adutoras Jaibaras-Sobral e Taquara-Sertão de Sobral (Projeto Malha d’Água)',
							desc: 'Abastecimento humano de Sobral, Forquilha, Massapê, Meruoca, Alcântaras, Santana do Acaraú, Cariré, Groaíras, Mucambo, Pacujá e Graça.',
							estagio: 'Projeto Básico',
							valor: 'R$ 372,31 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-017ab_ac_bg.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 8,
							titulo: 'Eixo de Integração Orós-Trussu e Sistemas Adutores Orós-Centro Sul e Trussu-Alto Jaguaribe (Projeto Malha d’Água)',
							desc: 'Abastecimento humano de Orós, Icó, Cedro, Granjeiro, Várzea Alegre, Farias Brito, Iguatu, Acopiara, Quixelô, Cariús, Jucás e Tarrafas',
							estagio: 'Projeto Básico',
							valor: 'R$ 552,32 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-017ae_ai_aw_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 9,
							titulo: 'Sistema Adutor Metropolitano-Litoral Leste (Projeto Malha d’Água)',
							desc: 'Abastecimento humano de Cascavel, Pindoretama, Aquiraz e Beberibe.',
							estagio: 'Projeto Básico',
							valor: 'R$ 227,03 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-017ag_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 10,
							titulo: 'Eixo de Integração Banabuiú-Pedras Brancas e Sistemas Adutores Banabuiú-Sertão Central e Pedras Brancas-Sertão Central (Projeto Malha d’Água)',
							desc: 'Abastecimento humano de Quixeramobim, Quixadá, Choró, Ibicuitinga, Banabuiú, Solonolópole, Jaguaretama, Milhã, Dep. Irapuan Pinheiro, S. Pompeu, Piquet Carneiro, Mombaça e Pedra Branca',
							estagio: 'Projeto Básico',
							valor: 'R$ 657,53 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-017ak_am_bl.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 11,
							titulo: 'Sistema Adutor Curral Velho-Vale do Jaguaribe (Projeto Malha d’Água)',
							desc: 'Abastecimento humano de Morada Nova, Limoeiro do Norte, Quixeré, Tabuleiro do Norte e São João do Jaguaribe',
							estagio: 'EVTEA',
							valor: 'R$ 1,40 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-017an_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 12,
							titulo: 'Sistema Adutor Vale do Curu-Litoral Oeste (Projeto Malha d’Água)',
							desc: 'Abastecimento humano de Croatá, Paracuru, Paraipaba, Pentecoste, São Luiz do Curu e Trairi.',
							estagio: 'Projeto Básico',
							valor: 'R$ 203,36 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-017ao_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 13,
							titulo: 'Sistema Adutor Fogareiro-Alto Banabuiú (Projeto Malha d’Água)',
							desc: 'Abastecimento humano de Boa Viagem, Monsenhor Tabosa, Madalena e Itatira',
							estagio: 'Projeto Básico',
							valor: 'R$ 241,82 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-017az.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 14,
							titulo: 'Sistema Produtor para a RM Fortaleza (ETA de Dessalinização)',
							desc: 'Abastecimento humano da RM Fortaleza',
							estagio: 'EVTEA',
							valor: 'R$ 4,75 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CE-041_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 15,
							titulo: 'Eixo Norte-Trecho III (Ramal do Salgado)',
							desc: 'Abastecimento humano e usos múltiplos nas bacias dos rios Salgado, Médio e Baixo Jaguaribe, RM Fortaleza e Complexo Industrial e Portuário do Pacém',
							estagio: 'EVTEA',
							valor: 'R$ 8,99 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_PISF-003_PISF-004.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 16,
							titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Fortaleza',
							desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Fortaleza',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Fortaleza.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 17,
							titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
							desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 0,80 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 18,
							titulo: 'Barragem Serra Negra do Norte (Nova Dinamarca)',
							desc: 'Abastecimento humano e uso industrial na bacia hidrográfica do rio Espinharas',
							estagio: 'EVTEA',
							valor: 'R$ 4,26 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_NS-003_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 19,
							titulo: 'Sistema Adutor Monsenhor Expedito (ampliação)',
							desc: 'Abastecimento humano em 44 municípios nas bacias hidrográficas dos rios Potengi, Trairi, Jacu e Curimataú',
							estagio: 'Anteprojeto',
							valor: 'R$ 114,41 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RN-004.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 20,
							titulo: 'Eixo de Integração Santa Cruz-Pau dos Ferros (adutora expressa)',
							desc: 'Abastecimento humano de Alexandria, Água Nova, J. da Penha, L. Gomes, M. Sales, Marcel. Vieira, Paraná, Pilões, Raf. Fernandes, R. de Santana, S. Fco do Oeste, Ten. Ananias e Pau dos Ferros',
							estagio: 'Projeto Básico',
							valor: 'R$ 113,05 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RN-009.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 21,
							titulo: 'Sistema Adutor Santa Cruz-Mossoró',
							desc: 'Abastecimento humano dos municípios Mossoró, Governador Dix-Sept Rosado, Felipe Guerra e 50 comunidades rurais',
							estagio: 'Obra',
							valor: 'R$ 139,72 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RN-015.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 22,
							titulo: 'Barragem Oiticica',
							desc: 'Abastecimento humano, irrigação e controle de cheias de 19 municípios na bacia hidrográfica do rio Piranhas',
							estagio: 'Obra',
							valor: 'R$ 261,11 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RN-018_034b_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 23,
							titulo: 'Sistema Adutor Armando Ribeiro Gonçalves-Currais Novos (Projeto Seridó)',
							desc: 'Abastecimento humano de Acari, Bodó,Cerro Corá, Cruzeta, Currais Novos, Florânia, Jardim do Seridó, Jucurutu, Lagoa Nova, São José do Seridó, São Vicente e Tenente Laurentino Cruz',
							estagio: 'Anteprojeto',
							valor: 'R$ 107,22 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RN-034a_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 24,
							titulo: 'Sistema Adutor Oiticica-Caicó (Projeto Seridó)',
							desc: 'Abastecimento humano de Caicó, Ipueira, Jardim de Piranhas, Ouro Branco, São Fernando, São João do Sabugi, Serra Negra do Norte e Timbaúba dos Batistas',
							estagio: 'Anteprojeto',
							valor: 'R$ 35,63 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RN-018_034b_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 25,
							titulo: 'Eixo Norte-Trecho IV (Ramal do Apodi)',
							desc: 'Usos múltiplos na bacia hidrográfica do rio Apodi',
							estagio: 'EVTEA',
							valor: 'R$ 27,86 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_PISF-003_PISF-004.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 26,
							titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Natal',
							desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Natal',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Natal.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 27,
							titulo: 'Barragem Bujari',
							desc: 'Abastecimento humano, irrigação, uso industrial e piscicultura em dez municípios no Rio Grande do Norte e cinco municípios na Paraíba, na bacia do rio Guaju',
							estagio: 'EVTEA',
							valor: 'R$ 0,40 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_NS-002.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 28,
							titulo: 'Canal Acauã-Araçagi/Vertentes Litorâneas - Trecho 1 e 2',
							desc: 'Usos múltiplos em Ingá, Mogeiro, Itabaiana, São José dos Ramos, Sobrado, Riachão do Poço, Sapé, Mari, Cuité de Mamanguape, Araçagi e Itapororoca',
							estagio: 'Obra',
							valor: 'R$ 426,32 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PB-001.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
						},
						{
							id: 29,
							titulo: 'Canal Acauã-Araçagi/Vertentes Litorâneas - Trecho 3',
							desc: 'Usos múltiplos em Ingá, Mogeiro, Itabaiana, São José dos Ramos, Sobrado, Riachão do Poço, Sapé, Mari, Cuité de Mamanguape, Araçagi e Itapororoca',
							estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
							valor: 'R$ 18,50 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 30,
							titulo: 'Ramal do Piancó',
							desc: 'Abastecimento humano, irrigação e uso industrial em Ingá, Mogeiro, Itabaiana, São José dos Ramos, Sobrado, Riachão do Poço, Sapé, Mari, Cuité de Mamanguape, Araçagi e Itapororoca',
							estagio: 'Anteprojeto',
							valor: 'R$ 240,27 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PB-002_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 31,
							titulo: 'Sistema Adutor Transparaíba (Ramal Cariri)',
							desc: 'Abastecimento de Amparo, Assunção, Gurjão, Junco do Seridó, Livramento, Monteiro, Ouro Velho, Parari, Prata, Santo André, S.J. do Cariri, S.J. dos Cordeiros, Serra Branca, Sumé e Taperoá',
							estagio: 'Anteprojeto',
							valor: 'R$ 330,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PB-003a_b_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 32,
							titulo: 'Sistema Adutor Transparaíba (Ramal Curimataú)',
							desc: 'Abastecimento humano de Araruna, Baraúna, Barra de Santa Rosa, Boa Vista, Cacimba de Dentro, Cubati, Cuité, Damião, Frei Martinho, Juazeirinho, Nova Floresta e mais sete municípios',
							estagio: 'Obra',
							valor: 'R$ 371,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PB-003a_b_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 33,
							titulo: 'Sistema Adutor (3º) de Campina Grande',
							desc: 'Abastecimento humano de Campina Grande, Queimadas, Pocinhos, Caturité, Barra de Santana, Lagoa Seca, Alagoa Nova, Matinhas e distritos de Galante e São José da Mata',
							estagio: 'EVTEA',
							valor: 'R$ 0,84 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PB-004_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 34,
							titulo: 'Sistema Adutor Nova Camará',
							desc: 'Abastecimento humano de Alagoa Nova, Algodão de Jandaíra, Arara, Areial, Esperança, Lagoa Seca, Matinhas, Montadas, Pocinhos, Puxinanã, Remígio e mais três municípios',
							estagio: 'Obra',
							valor: 'R$ 96,49 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PB-005_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 35,
							titulo: 'Sistema Adutor Abiaí-Papocas',
							desc: 'Abastecimento humano da Região Metropolitana de João Pessoa.',
							estagio: 'Obra',
							valor: 'R$ 62,83 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PB-033_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 36,
							titulo: 'Eixo Norte-Trechos I e II',
							desc: 'Abastecimento humano e usos múltiplos em bacias hidrográficas dos Estados de Pernambuco, da Paraíba, do Ceará e do Rio Grande do Norte',
							estagio: 'Obra',
							valor: 'R$ 244,89 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PISF-001_002_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 37,
							titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM João Pessoa',
							desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de João Pessoa ',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Joao Pessoa.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 38,
							titulo: 'Adutora Pajeú – 2ª Etapa',
							desc: 'Abastecimento humano em nove municípios de Pernambuco e seis da Paraíba, captando água no Eixo Leste do PISF',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 24,57 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_NS-001_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 39,
							titulo: 'Eixo Norte-Trecho III (Ramal do Salgado)',
							desc: 'Abastecimento humano e usos múltiplos nas bacias dos rios Salgado, Médio e Baixo Jaguaribe, RM Fortaleza e Complexo Industrial e Portuário do Pacém',
							estagio: 'EVTEA',
							valor: 'R$ 8,99 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_PISF-003_PISF-004.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 40,
							titulo: 'Sistema Adutor Bitury (ampliação)',
							desc: 'Abastecimento humano de Gravatá, Caruaru, Toritama, Santa Cruz do Capibaribe, Bezerros, Belo Jardim, Tacaimbó, São Bento do Una, Sanharó e São Caetano',
							estagio: 'Obra',
							valor: 'R$ 213,53 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PE-011_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 41,
							titulo: 'Sistema Adutor do Oeste (ampliação)',
							desc: 'Abastecimento humano de Orocó, Parnamirim, Terra Nova, Ouricuri, Araripina, Ipubi, Bodocó, Exu, Moreilândia, Granito, Santa Cruz, Santa Filomena e Trindade',
							estagio: 'EVTEA',
							valor: 'R$ 1,36 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PE-008-049_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 42,
							titulo: 'Canal do Sertão Pernambucano',
							desc: 'Usos múltiplos em 17 municípios nas bacias hidrográficas do Pontal, Garças e Brígida',
							estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
							valor: 'R$ 18,50 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 43,
							titulo: 'Sistema Adutor Negreiros-Chapéu',
							desc: 'Abastecimento humano de Parnamirim, Ouricuri, Araripina, Ipubi, Bodocó, Exu, Moreilândia, Granito, Santa Cruz, Santa Filomena e Trindade',
							estagio: 'EVTEA',
							valor: 'R$ 0,69 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PE-008-049_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
						{
							id: 44,
							titulo: 'Ramal do Entremontes',
							desc: 'Usos Múltiplos na Bacia Hidrográfica do rio Brígida',
							estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
							valor: 'R$ 18,50 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 45,
							titulo: 'Eixo Norte-Trechos I e II',
							desc: 'Abastecimento humano e usos múltiplos em bacias hidrográficas dos Estados de Pernambuco, Paraíba, Ceará e Rio Grande do Norte',
							estagio: 'Obra',
							valor: 'R$ 244,89 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PISF-001_002_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 46,
							titulo: 'Ramal do Agreste',
							desc: 'Abastecimento humano em 64 municípios da região do Agreste Pernambucano',
							estagio: 'Obra',
							valor: 'R$ 1.466,71 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PISF-007_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 47,
							titulo: 'Sistema Adutor do Agreste',
							desc: 'Abastecimento humano em 64 municípios da região do Agreste Pernambucano',
							estagio: 'Obra',
							valor: 'R$ 735,64 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PE-001_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
						{
							id: 48,
							titulo: 'Sistema Adutor Engenho Maranhão-ETA Suape',
							desc: 'Abastecimento humano de Cabo de Santo Agostinho, Recife e Jaboatão dos Guararapes',
							estagio: 'Projeto Básico',
							valor: 'R$ 232,27 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RMR_PE-027_028_057.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 49,
							titulo: 'Sistema Adutor Engenho Maranhão-ETA Suape',
							desc: 'Abastecimento humano de Cabo de Santo Agostinho, Recife e Jaboatão dos Guararapes',
							estagio: 'Projeto Básico',
							valor: 'R$ 232,27 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RMR_PE-027_028_057.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 50,
							titulo: 'Barragem Engenho Maranhão',
							desc: 'Abastecimento humano de Ipojuca, Cabo de Santo Agostinho, Recife e Jaboatão dos Guararapes',
							estagio: 'Obra',
							valor: 'R$ 81,05 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RMR_PE-027_028_057.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 51,
							titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Alta Vulnerabilidade a Inundações – Bacia Hidrográfica dos rios Mundaú e Paraíba',
							desc: 'Definição de alternativas de intervenções para prevenir e mitigar os efeitos das cheias nas Bacias Hidrográficas dos rios Mundaú e Paraíba',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 1,50 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR Cheias-Bacia Mundau-Paraiba.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 52,
							titulo: 'Sistema Adutor Tramo Sul (ampliação do Sistema Jucazinho)',
							desc: 'Abastecimento humano de Cumaru, Passira, Riacho das Almas, Caruaru, Santa Cruz do Capibaribe, Bezerros e Gravatá.',
							estagio: 'Obra',
							valor: 'R$ 19,62 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PE-020_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 53,
							titulo: 'Barragem Tracunhaém',
							desc: 'Abastecimento humano, irrigação e dessedentação animal nos municípios de Goiâna, Olinda, Paulista, Abreu e Lima e Igarassu',
							estagio: 'Anteprojeto',
							valor: 'R$ 323,62 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RMR_PE-032_073.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 54,
							titulo: 'Sistema Adutor Tracunhaém-EE Arataca II (ampliação)',
							desc: 'Abastecimento humano de Abreu e Lima, Igarassu, Olinda e Paulista',
							estagio: 'Anteprojeto',
							valor: 'R$ 427,86 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RMR_PE-032_073.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 55,
							titulo: 'Estudo de Aproveitamento de Recursos Hídricos da RM Recife',
							desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Recife',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Recife.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 56,
							titulo: 'Barragem Panelas II-Gatos',
							desc: 'Controle de cheias e abastecimento humano nos municípios de Belém de Maria e Catende',
							estagio: 'Obra',
							valor: 'R$ 138,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CC-PE-007.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 57,
							titulo: 'Barragem Igarapeba',
							desc: 'Controle de cheias e abastecimento humano nos municípios de Maraial, Jaqueira, Palmares, Água Preta e Barreiros',
							estagio: 'Obra',
							valor: 'R$ 173,23 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CC-PE-004.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 58,
							titulo: 'Sistema Adutor Engenho Maranhão-ETA Pirapama',
							desc: 'Abastecimento humano de Ipojuca, Cabo de Santo Agostinho, Recife e Jaboatão dos Guararapes',
							estagio: 'Anteprojeto',
							valor: 'R$ 386,47 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RMR_PE-027_028_057.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
				]
		}
	},

  methods: {
    ...mapActions({
        showModal: 'Layout/enviarInformacaoModal'
    }),
    mostarIntervencao (item, evt) {

      let payload = this.informacoes.filter((value) => {
          return value.id === item
			})

      this.showModal(payload[0]);
    }
  }
}
</script>


<style lang="scss" scoped>

.title-section {
    padding-left: 0px;
    height: 40px;
}

.interacao-intervencao {
	display: flex;
	align-items: center;
    width: 289px;
    @include media_tablet() {
      display: none;
    }
	svg {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}

	p {
		font-family: 'rubik_italic';
		font-size: 12px;
		line-height: 16px;
	}
}

svg {
    height: 450px;
    width: 100%;
    @media (max-height:  900px) and (min-width: 1200px)   {
        height: 350px;
    }
}

	.st0{fill:#3B6EB6;}
	.st1{fill:#93ACD9;}
	.st2{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}
	.st3{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}
	.st4{fill:#FFFFFF;}
	.st5{fill:#8FC74B;}
	.st6{fill:#010101;}
</style>
